import PlatformFooter from '../appComponents/mobile/PlatformFooter';
import '../appComponents/desktop/css/PlatformFooterDesktop.css';
import AvailableWalletBalance from '../appComponents/shared/crypto/AvailableWalletBalance';
import '../appComponents/desktop/css/DesktopModalStyles.css';
import { switchPlatformTheme } from '../appComponents/shared/ThemePreference';
import '../appComponents/shared/css/PlatformExperience.css';
import '../appComponents/shared/css/CreditFlowRefinement.css';
import './css/BorrowActionsPolish.css';
import './css/BorrowingAccountDesktopWalletFooter.css';
import PageLoading from '../appComponents/shared/PageLoading';
import { trackPageRequest } from '../appComponents/shared/PageLoadingService';
import '../appComponents/shared/crypto/css/OverlayTheme.css';
import StakeConfirmation from '../appComponents/shared/crypto/StakeConfirmation';
import { authenticatedPut } from '../appComponents/shared/AuthenticatedAPI';
import PasswordPrompt from '../appComponents/shared/crypto/PasswordPrompt';
import React, { Component } from 'react';

class BorrowingAccountDesktopRender extends Component {
  render() {
    const { API, AWS, Amplify, Auth, Bar, BorrowingAccount, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, CartesianGrid, Chart, Component, Container, CryptoJS, Form, FormField, Fragment, Header, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, Legend, Line, LineChart, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, Radio, React, ResponsiveContainer, Storage, ThreeDot, Tooltip, Web3, XAxis, YAxis, _approverReceivedRepaymentSum, _approversCt, _approversLoanTotal, _availableCreditReadyWithdraw, _balance, _blenderScore, _blockchainBalance, _borrowerInterestPaid, _borrowingRec, _canDeleteCreditLineBool, _compoundedBalance, _compoundedBalanceWEI, _currentUserContribution, _dateCreated, _exitReclaimableValueWei, _fico, _intRate, _joinDate, _lenders, _lendingRate, _lentTotal, _loanRate, _lookupKey, _managerLCase, _minLoan, _offeredLenderCommissionUSD_adjusted, _openValue, _payableValue, _reclaimableValue, _repayRate, _repaymentTotal, _riskCoverage, _safeReclaimableValueWei, _targetValue, _totalBorrowing, _totalContributed, _totalContributedWei, _totalLending, _totalPaid, _totalWithdrawn, _txnSectionHelpText, _userAvgRating, _userContributed, _userFinalized, _userInterestEarned, _values, _valuesONLY, _web3Balance, _weiCompoundedBalance, _withdrawalRate, accountStatsArray, actionButton, actionText, actionType, actionTypeStakingBool, approverCheck, approverReceivedRepaymentSum, approversCount, approversList, availableCredit, availableCreditRatio, availableCredit_unadjusted, awsconfig, axios, blacklisted, blenderCommissionPublicKey, blenderPercentCharge, blenderPrivateKey, blenderScore, blenderTransfersToPublicKey, borrowerInterestPaid, borrowerStatsArray, borrowingRec, buttonColorFlashIntervalDefault, buttonColorFlashIntervalSecondary, buttonText, campaign, checkValidAuthTokenIntervalPeriod_ms, className, client, closureDateFormatted, cognitoID, compoundInterestReceived, compoundedInterestPaid, contractAddress, contractBalance, contractReceipts, contractStructureType, contributeSignatureNeeded, conversionRateGlobal, corporateBackedUsernamesArray, costText, creditUtilizationPerc, currentUser, currentUserLoanTotal, dataIndexDayMap, deploymentAddress, displayValue, dob, emailAddress, ethers, fico, finalRequestsSum, firstName, forexJSON, formattedValueTooltipString, fullAddress, highRateWeb3, imaginaryInsuranceTotal, insuranceTotal, intRate, interactionHeader, interestRate, ipAddress, isCorporateBondBool, isMobile, lastName, lenderCount, lendingRate, loadingTextInterval, loadingTextIntervalCt, loanRate, loanTarget, manager, managerDisplay, managerUsername, maxDayValue, mediaArray, mediaArrayMap, mediaMapArrayUserMap, mimemessage, minDayValue, minLoan, minimumContribution, monthLengtheningEnum, navigationHandler, netDebt, noDailyDataPointsFoundBool, offeredLenderCommissionUSD, openContracts, openValue, phoneNumber, primaryDisplayCurrency, primaryDisplayPrice, primaryLanguage, proposeGasPrice, publicKey, rand1, receiptsCt, reclaimableValue, region, repaidRec, repayRate, repaymentSum, requests, requestsCt, riskCoveragePercentage, routeProps, secondaryDisplayCurrency, secondaryDisplayPrice, secretName, settlementDateFormatted, squareCustomerID, streetAddress, targetValue, that, thisContract_CampaignContract, thisContract_CampaignFactoryContract, thisDeploymentAddress, tokenLifeTimeLimit, tooltipInterval, totalBorrowing, totalContributed, totalCreditMax, totalLending, totalPaid, totalValue, totalWithdrawn, touched, transactionValue, useLayoutEffect, useParams, useRef, userContributed, userFinalized, userFinalizedRequestLoanSum, userInterestEarned, userLiquidValue, userLiquidValuePre, userRiskValue, value, valueDelta, web3, web3BalancePost, web3BalancePre, wishlist, wishlistIcon, withdrawalRate } = this.props;

    // Credit-line card values are read together from the native-equivalent
    // on-chain summary; transaction and chart values are deliberately separate.
    const formatCreditCardUSD = (value) => {
      if (value == null || value === '' || !Number.isFinite(Number(value))) return '—';
      return Math.max(0, Number(value)).toLocaleString(undefined, {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }) + ' USD' + '\n\n';
    };
    const realCreditLimit = that.state.displayCreditLimitUSD;
    const liquidAvailableCredit = that.state.displayAvailableCreditUSD;

    return (
(


          <div className={"pageBody tbp-platform tbp-platform--" + (that.state.mode_light_dark === 'light' ? 'light' : 'dark') + " tbp-platform--borrowing-account tbp-platform--desktop"}>
              <PageLoading theme={that.state.mode_light_dark} language={that.state.selectedLanguage} busy={Boolean(that.state.freezeButtonsBool || that.state.activityIndicator === true)} />

            <StakeConfirmation desktop
                open={that.state.successOverlay}
                confirmation={that.state.stakeConfirmation}
                onRetry={() => that.retryStakePendingTransaction()}
                theme={that.state.mode_light_dark}
                language={that.state.selectedLanguage}
                onClose={() => {
                    that.setState({ successOverlay: false, stakeConfirmation: null });
                    that.reloadPage();
                }}
            />

            
            <head>
              <script src="https://www.gstatic.com/charts/loader.js"></script>
            </head>



            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.popupBlockerOverlay}
              // open={true}
              style={{ 
                width: '35vw',
                height: '21vh',
              }}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                {that.state.selectedLanguage == 'spanish' ? 
                  `Se están bloqueadas las ventanas emergentes de Blender.`
                    :
                  `Your browser may be blocking Blender pop-ups.`
                }
              </Modal.Header>
              <Modal.Content image>
                {/* <Modal.Description> */}
                  <Header
                    style={{
                      left: '0vw',
                      position: 'relative',
                      paddingRight: '1vw',
                    }}
                  >
                    {that.state.selectedLanguage == 'spanish' ? 
                      `Habilite ventanas "pop-up" del browser para completar tu transacción.`
                      :
                      `Enable Pop-Up tabs and windows to complete your transaction.`
                    }
                  </Header>
                  <Button
                    content={that.state.selectedLanguage == 'spanish' ? "Bueno" : 'Okay'}
                    labelPosition='right'
                    icon='checkmark'
                    onClick={() => {
                      that.setState({
                        popupBlockerOverlay: false
                      })
                    }}
                    positive
                    style={{
                      backgroundColor: 'rgba(0, 158, 129, 1)',
                      position: 'absolute',
                      bottom: 21,
                      width: '7vw',
                      left: '14vw',
                    }}
                  />
                {/* </Modal.Description> */}
              
                
                </Modal.Content>
            </Modal>

      
            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
                open={that.state.errorTags}
                // open={true}
                style={{
                width: '25vw',
                justifyContent: 'center',
                alignItems: 'center',
                }}
            >
                <Modal.Header
                  style={{
                    paddingLeft: '7vh',
                  }}
                >
                  
                  The Blender Platform
                </Modal.Header>
              
                <Modal.Content 
                image
                style={{
                    justifyContent: 'space-between',
                    marginBottom: '1vh',
                }}
                >
                
                <Modal.Description
                    style={{
                    width: '25vw',
                    }}
                >
                    <Header
                    style={{
                        // left: '16vw',
                        fontSize: 20,
                        // position: 'absolute',
                        overflowY: 'hidden',
                        overflowX: 'hidden', 
                        width: '25vw',
                        marginBottom: 65,
                        paddingRight: '1vw',
                    }}
                    >
                        <p
                        style={{
                            color: 'rgba(235, 50, 38, 1)',
                            textAlign: 'left',
                            textWrap: 'wrap',
                        }}
                        >
                        {that.state.selectedLanguage == 'spanish' ? 
                            'Error:'
                                :
                            'Error:'
                        }
                        </p>
                        <p
                        style={{
                            color: 'rgba(0, 0, 0, 1)',
                            textAlign: 'left',
                            textWrap: 'wrap',
                            fontWeight: '400',
                            fontSize: 18,
                            paddingRight: '1vw',
                        }}
                        >
                        {that.state.errorTags}
                        </p>
                    </Header>
                </Modal.Description>
                </Modal.Content>
                <Button
                    content={
                        that.state.selectedLanguage == 'spanish' ? 
                        'Bueno'
                            :
                        'Okay'
                    }
                    labelPosition='right'
                    icon='checkmark'
                    onClick={() => {
                        that.setState({
                            successfulDepositOverlay: false,
                            errorTags: null
                        })
                    }}
                    positive
                    style={{
                        backgroundColor: 'rgba(0, 158, 129, 1)',
                        position: 'relative',
                        bottom: 21,
                        fontSize: 15,
                        width: '7vw',
                        marginLeft: '9vw',
                        marginRight: '9vw',
                        // left: '0vw',
                        borderRadius: 2,
                    }}
                />
            </Modal>



    
            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.pendingTransactionLoaderOverlay}
              // open={true}
              style={{
                width: '27vw',
              }}
              // trigger={<Button>Show Modal</Button>}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
              <Modal.Content image>
                <Modal.Description>
                  <Header
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginLeft: '2vw',
                      marginRight: '3vw',
                      marginTop: '0vw',
                      marginBottom: '0vw',
                      height: '5vw',
                    }}
                  >
                    <p
                      style={{
                        fontSize: 19,
                        color: 'rgba(0, 0, 0, 1)',
                        textAlign: 'left',
                        marginBottom: '2vh',
                      }}
                    >
                      {
                        that.state.selectedLanguage == 'spanish' 
                        ? 
                          "Transacción Pendiente"
                        :
                          "Transaction in Progress"
                      }
                    </p>
                    
                    <div
                      style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '4vw',
                        marginLeft: '3vw',
                        marginRight: '3vw',
                        // paddingLeft: '5vw',
                        // paddingRight: '5vw', 
                      }}
                    >
                      <div className="tbp-overlay-loading"><ThreeDot 
                        color="rgba(0, 158, 129, 1)" 
                        size="large" 
                        style={{
                          marginTop: 250,
                          speedPlus: -2,
                        }}
                      /></div>
                    </div>
                  
                  </Header>
                  
                </Modal.Description>
                
              </Modal.Content>
            </Modal>
            

            <Modal
              centered={true}
              dimmer={{ className: "tbp-overlay-backdrop" }}
              className="tbp-desktop-social-modal" open={that.state.socialOverlay}
              style={{
                width: 'min(1050px, 92vw)',
                maxWidth: 1050,
                height: 'auto',
                maxHeight: '90vh',
                padding: 0,
                margin: '0 auto',
                overflow: 'hidden',
                borderRadius: 14,
                boxSizing: 'border-box',
                backgroundColor:
                  that.state.mode_light_dark == 'light'
                    ? '#e0e1e2'
                    : '#232324',
                color:
                  that.state.mode_light_dark == 'light'
                    ? '#171717'
                    : '#ffffff',
              }}
            >
              <div
                style={{
                  width: '100%',
                  maxHeight: '90vh',
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  backgroundColor:
                    that.state.mode_light_dark == 'light'
                      ? '#e0e1e2'
                      : '#232324',
                }}
              >

                {/* TOP BAR */}
                <div
                  style={{
                    minHeight: 54,
                    padding: '10px 14px',
                    boxSizing: 'border-box',
                    backgroundColor: 'rgba(0, 158, 129, 1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <button
                    onClick={() => {
                      that.setState({
                        // IMPORTANT: only close the overlay.
                        // BorrowingAccount loads this profile data with the account,
                        // so clearing it here makes the profile/avatar disappear
                        // and reopening the overlay has nothing left to render.
                        socialOverlay: false,
                      })
                    }}
                    style={{
                      width: 38,
                      height: 38,
                      border: 0,
                      borderRadius: 19,
                      backgroundColor: 'rgba(204, 12, 12, 0.95)',
                      color: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <i
                      className="close icon"
                      style={{ margin: 0, fontSize: 17 }}
                    />
                  </button>

                  <div
                    style={{
                      color: '#ffffff',
                      fontSize: 18,
                      fontWeight: '700',
                    }}
                  >
                    {that.state.selectedLanguage == 'spanish'
                      ? 'Perfil del Miembro'
                      : 'Member Profile'}
                  </div>

                  <Link
                    to={`/borrowingacct/${that.state.socialOverlayData_contractAddress}`}
                    onClick={() => {
                      that.setState({
                        socialOverlay: false,
                        commentViewerMediaFileName: null,
                      })
                    }}
                    style={{
                      width: 38,
                      height: 38,
                      borderRadius: 19,
                      backgroundColor: 'rgba(255, 255, 255, 0.18)',
                      color: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textDecoration: 'none',
                    }}
                  >
                    <i
                      className="arrow right icon"
                      style={{ margin: 0, fontSize: 17 }}
                    />
                  </Link>
                </div>

                {/* PROFILE */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 24,
                    padding: '26px 30px',
                    borderBottom:
                      that.state.mode_light_dark == 'light'
                        ? '1px solid rgba(0,0,0,0.10)'
                        : '1px solid rgba(255,255,255,0.10)',
                  }}
                >
                  <img
                    src={that.state.socialOverlayData_imageURI}
                    alt=""
                    style={{
                      width: 115,
                      height: 115,
                      minWidth: 115,
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: '2px solid rgba(0, 158, 129, 1)',
                    }}
                  />

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        color: 'rgba(0, 158, 129, 1)',
                        fontSize: 27,
                        fontWeight: '700',
                        overflowWrap: 'anywhere',
                      }}
                    >
                      {String(
                        (
                        String(that.state.socialOverlayData_username || '').toLowerCase() ===
                        String(that.state.managerUsername || '').toLowerCase()
                          ? (that.state.managerDisplayName || that.state.socialOverlayData_username)
                          : that.state.socialOverlayData_username
                      ) ||
                      ''
                      ).toUpperCase()}
                    </div>

                    <div
                      style={{
                        marginTop: 5,
                        fontSize: 17,
                        fontWeight: '600',
                        color:
                          that.state.mode_light_dark == 'light'
                            ? '#171717'
                            : '#ffffff',
                      }}
                    >
                      {String(
                        that.state.socialOverlayData_username || ''
                      ).toUpperCase()}
                    </div>

                    <div
                      style={{
                        marginTop: 4,
                        fontSize: 15,
                        color:
                          that.state.mode_light_dark == 'light'
                            ? '#555555'
                            : '#bbbbbb',
                      }}
                    >
                      {that.state.socialOverlayData_fullName}
                    </div>

                    <div
                      style={{
                        marginTop: 12,
                        fontSize: 15,
                        lineHeight: 1.5,
                        color:
                          that.state.mode_light_dark == 'light'
                            ? '#333333'
                            : '#dddddd',
                      }}
                    >
                      {String(
                        that.state.socialOverlayData_bioString || ''
                      ).substring(0, 200)}
                    </div>
                  </div>
                </div>

                {/* POSTS */}
                <div style={{ padding: '24px 30px 32px' }}>

                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: '700',
                      color: 'rgba(0, 158, 129, 1)',
                      marginBottom: 18,
                    }}
                  >
                    {that.state.selectedLanguage == 'spanish'
                      ? 'Publicaciones'
                      : 'Posts'}
                  </div>

                  {
                    that.state.mediaMapArray &&
                    that.state.mediaMapArray.length > 0
                    ?
                      that.state.mediaMapArray.map((listItemA, mediaIndex) => (

                        <div
                          key={listItemA.mediaFileName || mediaIndex}
                          style={{
                            width: '100%',
                            display: 'grid',
                            gridTemplateColumns:
                              'minmax(320px, 1fr) minmax(300px, 0.85fr)',
                            gap: 22,
                            padding: 18,
                            marginBottom: 24,
                            boxSizing: 'border-box',
                            borderRadius: 12,
                            backgroundColor:
                              that.state.mode_light_dark == 'light'
                                ? '#ffffff'
                                : '#2d2d2f',
                            border:
                              that.state.mode_light_dark == 'light'
                                ? '1px solid rgba(0,0,0,0.08)'
                                : '1px solid rgba(255,255,255,0.08)',
                          }}
                        >

                          {/* MEDIA */}
                          <div>
                            {
                              String(listItemA.mediaURI || '')
                                .toLowerCase()
                                .includes('mp4')
                              ?
                                <video
                                  controls
                                  style={{
                                    width: '100%',
                                    maxHeight: 560,
                                    borderRadius: 8,
                                    objectFit: 'contain',
                                    backgroundColor: '#000000',
                                  }}
                                >
                                  <source
                                    src={listItemA.mediaURI}
                                    type="video/mp4"
                                  />
                                </video>
                              :
                                <img
                                  src={listItemA.mediaURI}
                                  alt=""
                                  style={{
                                    width: '100%',
                                    maxHeight: 560,
                                    borderRadius: 8,
                                    objectFit: 'contain',
                                    display: 'block',
                                    backgroundColor: '#000000',
                                  }}
                                />
                            }

                            {/* POST ACTIONS */}
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                marginTop: 12,
                              }}
                            >
                              {/* LIKE PHOTO */}
                              <Button
                                onClick={() => {
                                  let likesArray = []

                                  API.put('api1169ba1e', '', {
                                    headers: {
                                      Authorization: `Bearer ${cognitoID}`
                                    },
                                    body: {
                                      category: 'db',
                                      tableName: 'mediaUploads',
                                      primaryKey: String(listItemA.mediaFileName),
                                      requestOperation: 'get',
                                    }
                                  }).then((mediaData) => {

                                    if (
                                      mediaData.hasOwnProperty('Item') &&
                                      mediaData.Item.hasOwnProperty('likesArray')
                                    ) {
                                      likesArray = [...mediaData.Item.likesArray]
                                    }

                                    const username = currentUser.toLowerCase()

                                    if (likesArray.includes(username)) {
                                      likesArray.splice(
                                        likesArray.indexOf(username),
                                        1
                                      )
                                    } else {
                                      likesArray.push(username)
                                    }

                                    API.put('api1169ba1e', '', {
                                      headers: {
                                        Authorization: `Bearer ${cognitoID}`
                                      },
                                      body: {
                                        category: 'db',
                                        tableName: 'mediaUploads',
                                        primaryKey: String(listItemA.mediaFileName),
                                        requestOperation: 'update',
                                        updateExpression:
                                          'SET likesArray = :likesArray',
                                        expressionAttributeValues: {
                                          ':likesArray': likesArray,
                                        }
                                      }
                                    }).then(() => {
                                      listItemA.likesArray = likesArray

                                      that.setState({
                                        mediaMapArray: [
                                          ...that.state.mediaMapArray
                                        ]
                                      })
                                    })
                                  })
                                }}
                                style={{
                                  backgroundColor: 'transparent',
                                  boxShadow: 'none',
                                  padding: 8,
                                }}
                              >
                                <i
                                  className={
                                    listItemA.likesArray &&
                                    listItemA.likesArray.includes(
                                      currentUser.toLowerCase()
                                    )
                                    ? 'heart icon'
                                    : 'heart outline icon'
                                  }
                                  style={{
                                    color: 'rgba(204, 12, 12, 1)',
                                    fontSize: 25,
                                    margin: 0,
                                  }}
                                />

                                <span
                                  style={{
                                    marginLeft: 6,
                                    color: 'rgba(204, 12, 12, 1)',
                                    fontWeight: '600',
                                  }}
                                >
                                  {
                                    listItemA.likesArray
                                      ? listItemA.likesArray.length
                                      : 0
                                  }
                                </span>
                              </Button>

                              {/* NEW COMMENT */}
                              <Button
                                onClick={() => {
                                  that.setState({
                                    commentReplyID: null,
                                    newCommentStringInput: '',
                                    commentInitMediaFileName:
                                      listItemA.mediaFileName,
                                  })
                                }}
                                style={{
                                  backgroundColor: 'transparent',
                                  boxShadow: 'none',
                                  padding: 8,
                                }}
                              >
                                <i
                                  className="pen square icon"
                                  style={{
                                    color: 'rgba(0, 158, 129, 1)',
                                    fontSize: 24,
                                    margin: 0,
                                  }}
                                />

                                <span
                                  style={{
                                    marginLeft: 6,
                                    color: 'rgba(0, 158, 129, 1)',
                                    fontWeight: '600',
                                  }}
                                >
                                  {that.state.selectedLanguage == 'spanish'
                                    ? 'Comentar'
                                    : 'Comment'}
                                </span>
                              </Button>
                            </div>
                          </div>

                          {/* CAPTION + COMMENTS */}
                          <div
                            style={{
                              minWidth: 0,
                              maxHeight: 560,
                              overflowY: 'auto',
                              paddingRight: 8,
                            }}
                          >

                            {/* CAPTION */}
                            <div
                              style={{
                                paddingBottom: 14,
                                marginBottom: 14,
                                borderBottom:
                                  that.state.mode_light_dark == 'light'
                                    ? '1px solid rgba(0,0,0,0.08)'
                                    : '1px solid rgba(255,255,255,0.08)',
                              }}
                            >
                              <div
                                style={{
                                  fontSize: 15,
                                  fontWeight: '700',
                                  color:
                                    that.state.mode_light_dark == 'light'
                                      ? '#171717'
                                      : '#ffffff',
                                }}
                              >
                                {String(
                                  listItemA.publisherUsername || ''
                                ).toUpperCase()}
                              </div>

                              <div
                                style={{
                                  marginTop: 7,
                                  fontSize: 14,
                                  lineHeight: 1.5,
                                  color:
                                    that.state.mode_light_dark == 'light'
                                      ? '#333333'
                                      : '#dddddd',
                                  overflowWrap: 'anywhere',
                                }}
                              >
                                {listItemA.mediaItemCaption}
                              </div>
                            </div>

                            {/* ADD COMMENT INPUT */}
                            {
                              that.state.commentInitMediaFileName ==
                              listItemA.mediaFileName
                              ?
                                <div
                                  style={{
                                    marginBottom: 18,
                                    padding: 12,
                                    borderRadius: 8,
                                    backgroundColor:
                                      that.state.mode_light_dark == 'light'
                                        ? '#f4f4f4'
                                        : '#38383a',
                                  }}
                                >
                                  <input
                                    autoComplete="off"
                                    type="text"
                                    value={
                                      that.state.newCommentStringInput || ''
                                    }
                                    maxLength="275"
                                    onChange={(event) => {
                                      that.setState({
                                        newCommentStringInput:
                                          event.target.value
                                      })
                                    }}
                                    placeholder={
                                      that.state.selectedLanguage == 'spanish'
                                        ? 'Escribe un comentario'
                                        : 'Write a comment'
                                    }
                                    style={{
                                      width: '100%',
                                      boxSizing: 'border-box',
                                      padding: '11px 12px',
                                      borderRadius: 6,
                                      border:
                                        '1px solid rgba(0,158,129,0.35)',
                                      outline: 'none',
                                      color:
                                        that.state.mode_light_dark == 'light'
                                          ? '#171717'
                                          : '#ffffff',
                                      backgroundColor:
                                        that.state.mode_light_dark == 'light'
                                          ? '#ffffff'
                                          : '#232324',
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'flex-end',
                                      gap: 8,
                                      marginTop: 9,
                                    }}
                                  >
                                    <Button
                                      onClick={() => {
                                        that.setState({
                                          newCommentStringInput: null,
                                          commentInitMediaFileName: null,
                                        })
                                      }}
                                    >
                                      {that.state.selectedLanguage == 'spanish'
                                        ? 'Cancelar'
                                        : 'Cancel'}
                                    </Button>

                                    <Button
                                      onClick={() => {

                                        if (
                                          !that.state.newCommentStringInput ||
                                          String(
                                            that.state.newCommentStringInput
                                          ).trim().length < 2
                                        ) {
                                          return
                                        }

                                        var randomString1 =
                                          String(Date.now()) +
                                          Math.random()
                                            .toString(36)
                                            .substring(2, 15) +
                                          Math.random()
                                            .toString(36)
                                            .substring(2, 15)

                                        randomString1 =
                                          String(currentUser).concat(
                                            randomString1.substring(0, 18)
                                          )

                                        const newComment = {
                                          sender: currentUser.toLowerCase(),
                                          sentTimestamp: Date.now(),
                                          messageText: String(
                                            that.state.newCommentStringInput
                                          ),
                                          messageID: randomString1,
                                          subReplyCommentsArray: [],
                                          commentsReplyMapArray: [],
                                          likesArray: [],
                                          profilePictureURI:
                                            that.state.currentUserProfilePicture ||
                                            null,
                                        }

                                        API.put('api1169ba1e', '', {
                                          headers: {
                                            Authorization:
                                              `Bearer ${cognitoID}`
                                          },
                                          body: {
                                            category: 'db',
                                            tableName: 'mediaUploads',
                                            primaryKey:
                                              String(listItemA.mediaFileName),
                                            requestOperation: 'update',
                                            updateExpression:
                                              'SET commentsMapArray = list_append(commentsMapArray, :newCommentMap)',
                                            expressionAttributeValues: {
                                              ':newCommentMap': [
                                                {
                                                  sender:
                                                    currentUser.toLowerCase(),
                                                  sentTimestamp: Date.now(),
                                                  messageText:
                                                    String(
                                                      that.state
                                                        .newCommentStringInput
                                                    ),
                                                  messageID: randomString1,
                                                  subReplyCommentsArray: [],
                                                  likesArray: [],
                                                }
                                              ]
                                            }
                                          }
                                        }).then(() => {

                                          API.put('api1169ba1e', '', {
                                            headers: {
                                              Authorization:
                                                `Bearer ${cognitoID}`
                                            },
                                            body: {
                                              category: 'db',
                                              tableName:
                                                'mediaUploadComments',
                                              primaryKey: randomString1,
                                              requestOperation: 'update',
                                              updateExpression:
                                                'SET commentsReplyMapArray = :commentsReplyMapArray, isReplyBool = :isReplyBool, likesArray = :likesArray',
                                              expressionAttributeValues: {
                                                ':commentsReplyMapArray': [],
                                                ':isReplyBool': false,
                                                ':likesArray': [],
                                              }
                                            }
                                          }).then(() => {

                                            if (!listItemA.commentsMapArray) {
                                              listItemA.commentsMapArray = []
                                            }

                                            listItemA.commentsMapArray.push(
                                              newComment
                                            )

                                            that.setState({
                                              newCommentStringInput: null,
                                              commentInitMediaFileName: null,
                                              mediaMapArray: [
                                                ...that.state.mediaMapArray
                                              ]
                                            })
                                          })
                                        })
                                      }}
                                      style={{
                                        backgroundColor:
                                          'rgba(0, 158, 129, 1)',
                                        color: '#ffffff',
                                      }}
                                    >
                                      {that.state.selectedLanguage == 'spanish'
                                        ? 'Comentar'
                                        : 'Comment'}
                                    </Button>
                                  </div>
                                </div>
                              :
                                null
                            }

                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: '700',
                                color: 'rgba(0, 158, 129, 1)',
                                marginBottom: 10,
                              }}
                            >
                              {that.state.selectedLanguage == 'spanish'
                                ? 'Comentarios'
                                : 'Comments'}
                            </div>

                            {/* COMMENTS */}
                            {
                              listItemA.commentsMapArray &&
                              listItemA.commentsMapArray.length > 0
                              ?
                                listItemA.commentsMapArray.map(
                                  (listItemB, commentIndex) => (

                                    <div
                                      key={
                                        listItemB.messageID ||
                                        commentIndex
                                      }
                                      style={{
                                        display: 'flex',
                                        gap: 10,
                                        marginBottom: 16,
                                      }}
                                    >
                                      {
                                        listItemB.profilePictureURI
                                        ?
                                          <img
                                            src={
                                              listItemB.profilePictureURI
                                            }
                                            alt=""
                                            style={{
                                              width: 38,
                                              height: 38,
                                              minWidth: 38,
                                              borderRadius: 19,
                                              objectFit: 'cover',
                                            }}
                                          />
                                        :
                                          <div
                                            style={{
                                              width: 38,
                                              height: 38,
                                              minWidth: 38,
                                              borderRadius: 19,
                                              backgroundColor:
                                                'rgba(0,158,129,0.18)',
                                            }}
                                          />
                                      }

                                      <div
                                        style={{
                                          flex: 1,
                                          minWidth: 0,
                                        }}
                                      >
                                        <div
                                          style={{
                                            fontSize: 13,
                                            fontWeight: '700',
                                            color:
                                              that.state.mode_light_dark ==
                                              'light'
                                                ? '#171717'
                                                : '#ffffff',
                                          }}
                                        >
                                          {String(
                                            listItemB.sender || ''
                                          ).toUpperCase()}
                                        </div>

                                        <div
                                          style={{
                                            marginTop: 3,
                                            fontSize: 13,
                                            lineHeight: 1.45,
                                            color:
                                              that.state.mode_light_dark ==
                                              'light'
                                                ? '#333333'
                                                : '#dddddd',
                                            overflowWrap: 'anywhere',
                                          }}
                                        >
                                          {listItemB.messageText}
                                        </div>

                                        {/* COMMENT ACTIONS */}
                                        <div
                                          style={{
                                            display: 'flex',
                                            gap: 12,
                                            alignItems: 'center',
                                            marginTop: 6,
                                          }}
                                        >
                                          {/* LIKE COMMENT */}
                                          <button
                                            onClick={() => {

                                              API.put(
                                                'api1169ba1e',
                                                '',
                                                {
                                                  headers: {
                                                    Authorization:
                                                      `Bearer ${cognitoID}`
                                                  },
                                                  body: {
                                                    category: 'db',
                                                    tableName:
                                                      'mediaUploadComments',
                                                    primaryKey:
                                                      String(
                                                        listItemB.messageID
                                                      ),
                                                    requestOperation: 'get',
                                                  }
                                                }
                                              ).then((commentData) => {

                                                let likesArray =
                                                  commentData.Item &&
                                                  commentData.Item.likesArray
                                                  ? [
                                                      ...commentData.Item
                                                        .likesArray
                                                    ]
                                                  : []

                                                const username =
                                                  currentUser.toLowerCase()

                                                if (
                                                  likesArray.includes(username)
                                                ) {
                                                  likesArray.splice(
                                                    likesArray.indexOf(
                                                      username
                                                    ),
                                                    1
                                                  )
                                                } else {
                                                  likesArray.push(username)
                                                }

                                                API.put(
                                                  'api1169ba1e',
                                                  '',
                                                  {
                                                    headers: {
                                                      Authorization:
                                                        `Bearer ${cognitoID}`
                                                    },
                                                    body: {
                                                      category: 'db',
                                                      tableName:
                                                        'mediaUploadComments',
                                                      primaryKey:
                                                        String(
                                                          listItemB.messageID
                                                        ),
                                                      requestOperation:
                                                        'update',
                                                      updateExpression:
                                                        'SET likesArray = :likesArray',
                                                      expressionAttributeValues: {
                                                        ':likesArray':
                                                          likesArray
                                                      }
                                                    }
                                                  }
                                                ).then(() => {
                                                  listItemB.likesArray =
                                                    likesArray

                                                  that.setState({
                                                    mediaMapArray: [
                                                      ...that.state
                                                        .mediaMapArray
                                                    ]
                                                  })
                                                })
                                              })
                                            }}
                                            style={{
                                              border: 0,
                                              padding: 0,
                                              background: 'transparent',
                                              cursor: 'pointer',
                                              color:
                                                'rgba(204,12,12,1)',
                                              fontSize: 12,
                                              fontWeight: '600',
                                            }}
                                          >
                                            <i
                                              className={
                                                listItemB.likesArray &&
                                                listItemB.likesArray.includes(
                                                  currentUser.toLowerCase()
                                                )
                                                  ? 'heart icon'
                                                  : 'heart outline icon'
                                              }
                                            />

                                            {
                                              listItemB.likesArray
                                                ? listItemB.likesArray
                                                    .length
                                                : 0
                                            }
                                          </button>

                                          {/* REPLY */}
                                          <button
                                            onClick={() => {
                                              that.setState({
                                                newCommentStringInput: '',
                                                commentReplyID:
                                                  listItemB.messageID,
                                                commentInitMediaFileName:
                                                  null,
                                              })
                                            }}
                                            style={{
                                              border: 0,
                                              padding: 0,
                                              background: 'transparent',
                                              cursor: 'pointer',
                                              color:
                                                'rgba(0,158,129,1)',
                                              fontSize: 12,
                                              fontWeight: '600',
                                            }}
                                          >
                                            <i className="reply icon" />

                                            {that.state.selectedLanguage ==
                                            'spanish'
                                              ? 'Responder'
                                              : 'Reply'}
                                          </button>
                                        </div>

                                        {/* REPLY INPUT */}
                                        {
                                          that.state.commentReplyID ==
                                          listItemB.messageID
                                          ?
                                            <div
                                              style={{
                                                marginTop: 10,
                                              }}
                                            >
                                              <input
                                                autoComplete="off"
                                                type="text"
                                                value={
                                                  that.state
                                                    .newCommentStringInput ||
                                                  ''
                                                }
                                                maxLength="275"
                                                onChange={(event) => {
                                                  that.setState({
                                                    newCommentStringInput:
                                                      event.target.value
                                                  })
                                                }}
                                                placeholder={
                                                  that.state
                                                    .selectedLanguage ==
                                                  'spanish'
                                                    ? 'Escribe una respuesta'
                                                    : 'Write a reply'
                                                }
                                                style={{
                                                  width: '100%',
                                                  boxSizing: 'border-box',
                                                  padding: '9px 10px',
                                                  borderRadius: 6,
                                                  border:
                                                    '1px solid rgba(0,158,129,0.35)',
                                                  backgroundColor:
                                                    that.state
                                                      .mode_light_dark ==
                                                    'light'
                                                      ? '#ffffff'
                                                      : '#232324',
                                                  color:
                                                    that.state
                                                      .mode_light_dark ==
                                                    'light'
                                                      ? '#171717'
                                                      : '#ffffff',
                                                }}
                                              />

                                              <div
                                                style={{
                                                  display: 'flex',
                                                  justifyContent:
                                                    'flex-end',
                                                  gap: 7,
                                                  marginTop: 7,
                                                }}
                                              >
                                                <Button
                                                  size="mini"
                                                  onClick={() => {
                                                    that.setState({
                                                      newCommentStringInput:
                                                        null,
                                                      commentReplyID: null,
                                                    })
                                                  }}
                                                >
                                                  {that.state
                                                    .selectedLanguage ==
                                                  'spanish'
                                                    ? 'Cancelar'
                                                    : 'Cancel'}
                                                </Button>

                                                <Button
                                                  size="mini"
                                                  onClick={() => {

                                                    if (
                                                      !that.state
                                                        .newCommentStringInput ||
                                                      String(
                                                        that.state
                                                          .newCommentStringInput
                                                      ).trim().length < 2
                                                    ) {
                                                      return
                                                    }

                                                    var randomString1 =
                                                      String(Date.now()) +
                                                      Math.random()
                                                        .toString(36)
                                                        .substring(2, 15) +
                                                      Math.random()
                                                        .toString(36)
                                                        .substring(2, 15)

                                                    randomString1 =
                                                      String(
                                                        currentUser
                                                      ).concat(
                                                        randomString1.substring(
                                                          0,
                                                          18
                                                        )
                                                      )

                                                    const newReply = {
                                                      sender:
                                                        currentUser.toLowerCase(),
                                                      sentTimestamp:
                                                        Date.now(),
                                                      messageText:
                                                        String(
                                                          that.state
                                                            .newCommentStringInput
                                                        ),
                                                      messageID:
                                                        randomString1,
                                                      rootMessageID:
                                                        listItemB.messageID,
                                                      likesArray: [],
                                                      profilePictureURI:
                                                        that.state
                                                          .currentUserProfilePicture ||
                                                        null,
                                                    }

                                                    API.put(
                                                      'api1169ba1e',
                                                      '',
                                                      {
                                                        headers: {
                                                          Authorization:
                                                            `Bearer ${cognitoID}`
                                                        },
                                                        body: {
                                                          category: 'db',
                                                          tableName:
                                                            'mediaUploadComments',
                                                          primaryKey:
                                                            listItemB.messageID,
                                                          requestOperation:
                                                            'update',
                                                          updateExpression:
                                                            'SET commentsReplyMapArray = list_append(commentsReplyMapArray, :newCommentReplyMap)',
                                                          expressionAttributeValues: {
                                                            ':newCommentReplyMap':
                                                              [
                                                                {
                                                                  sender:
                                                                    currentUser.toLowerCase(),
                                                                  sentTimestamp:
                                                                    Date.now(),
                                                                  messageText:
                                                                    String(
                                                                      that
                                                                        .state
                                                                        .newCommentStringInput
                                                                    ),
                                                                  messageID:
                                                                    randomString1,
                                                                  rootMessageID:
                                                                    listItemB.messageID,
                                                                  likesArray:
                                                                    [],
                                                                }
                                                              ]
                                                          }
                                                        }
                                                      }
                                                    ).then(() => {

                                                      if (
                                                        !listItemB
                                                          .commentsReplyMapArray
                                                      ) {
                                                        listItemB.commentsReplyMapArray =
                                                          []
                                                      }

                                                      listItemB.commentsReplyMapArray.push(
                                                        newReply
                                                      )

                                                      that.setState({
                                                        newCommentStringInput:
                                                          null,
                                                        commentReplyID: null,
                                                        mediaMapArray: [
                                                          ...that.state
                                                            .mediaMapArray
                                                        ]
                                                      })
                                                    })
                                                  }}
                                                  style={{
                                                    backgroundColor:
                                                      'rgba(0,158,129,1)',
                                                    color: '#ffffff',
                                                  }}
                                                >
                                                  {that.state
                                                    .selectedLanguage ==
                                                  'spanish'
                                                    ? 'Responder'
                                                    : 'Reply'}
                                                </Button>
                                              </div>
                                            </div>
                                          :
                                            null
                                        }

                                        {/* REPLIES */}
                                        {
                                          listItemB.commentsReplyMapArray &&
                                          listItemB.commentsReplyMapArray
                                            .length > 0
                                          ?
                                            <div
                                              style={{
                                                marginTop: 12,
                                                marginLeft: 12,
                                                paddingLeft: 12,
                                                borderLeft:
                                                  '2px solid rgba(0,158,129,0.30)',
                                              }}
                                            >
                                              {
                                                listItemB.commentsReplyMapArray.map(
                                                  (
                                                    listItemE,
                                                    replyIndex
                                                  ) => (

                                                    <div
                                                      key={
                                                        listItemE.messageID ||
                                                        replyIndex
                                                      }
                                                      style={{
                                                        display: 'flex',
                                                        gap: 8,
                                                        marginBottom: 10,
                                                      }}
                                                    >
                                                      {
                                                        listItemE.profilePictureURI
                                                        ?
                                                          <img
                                                            src={
                                                              listItemE.profilePictureURI
                                                            }
                                                            alt=""
                                                            style={{
                                                              width: 30,
                                                              height: 30,
                                                              minWidth: 30,
                                                              borderRadius: 15,
                                                              objectFit:
                                                                'cover',
                                                            }}
                                                          />
                                                        :
                                                          <div
                                                            style={{
                                                              width: 30,
                                                              height: 30,
                                                              minWidth: 30,
                                                              borderRadius: 15,
                                                              backgroundColor:
                                                                'rgba(0,158,129,0.18)',
                                                            }}
                                                          />
                                                      }

                                                      <div
                                                        style={{
                                                          flex: 1,
                                                          minWidth: 0,
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            fontSize: 12,
                                                            fontWeight:
                                                              '700',
                                                            color:
                                                              that.state
                                                                .mode_light_dark ==
                                                              'light'
                                                                ? '#171717'
                                                                : '#ffffff',
                                                          }}
                                                        >
                                                          {String(
                                                            listItemE.sender ||
                                                            ''
                                                          ).toUpperCase()}
                                                        </div>

                                                        <div
                                                          style={{
                                                            marginTop: 2,
                                                            fontSize: 12,
                                                            lineHeight: 1.4,
                                                            color:
                                                              that.state
                                                                .mode_light_dark ==
                                                              'light'
                                                                ? '#444444'
                                                                : '#cccccc',
                                                          }}
                                                        >
                                                          {
                                                            listItemE.messageText
                                                          }
                                                        </div>

                                                        {/* LIKE REPLY */}
                                                        <button
                                                          onClick={() => {

                                                            API.put(
                                                              'api1169ba1e',
                                                              '',
                                                              {
                                                                headers: {
                                                                  Authorization:
                                                                    `Bearer ${cognitoID}`
                                                                },
                                                                body: {
                                                                  category:
                                                                    'db',
                                                                  tableName:
                                                                    'mediaUploadComments',
                                                                  primaryKey:
                                                                    String(
                                                                      listItemE.rootMessageID
                                                                    ),
                                                                  requestOperation:
                                                                    'get',
                                                                }
                                                              }
                                                            ).then(
                                                              (
                                                                commentData
                                                              ) => {

                                                                let replies =
                                                                  commentData
                                                                    .Item &&
                                                                  commentData
                                                                    .Item
                                                                    .commentsReplyMapArray
                                                                  ? [
                                                                      ...commentData
                                                                        .Item
                                                                        .commentsReplyMapArray
                                                                    ]
                                                                  : []

                                                                const targetIndex =
                                                                  replies.findIndex(
                                                                    (
                                                                      reply
                                                                    ) =>
                                                                      reply.messageID ==
                                                                      listItemE.messageID
                                                                  )

                                                                if (
                                                                  targetIndex <
                                                                  0
                                                                ) {
                                                                  return
                                                                }

                                                                let likesArray =
                                                                  replies[
                                                                    targetIndex
                                                                  ]
                                                                    .likesArray
                                                                  ? [
                                                                      ...replies[
                                                                        targetIndex
                                                                      ]
                                                                        .likesArray
                                                                    ]
                                                                  : []

                                                                const username =
                                                                  currentUser.toLowerCase()

                                                                if (
                                                                  likesArray.includes(
                                                                    username
                                                                  )
                                                                ) {
                                                                  likesArray.splice(
                                                                    likesArray.indexOf(
                                                                      username
                                                                    ),
                                                                    1
                                                                  )
                                                                } else {
                                                                  likesArray.push(
                                                                    username
                                                                  )
                                                                }

                                                                replies[
                                                                  targetIndex
                                                                ].likesArray =
                                                                  likesArray

                                                                API.put(
                                                                  'api1169ba1e',
                                                                  '',
                                                                  {
                                                                    headers:
                                                                      {
                                                                        Authorization:
                                                                          `Bearer ${cognitoID}`
                                                                      },
                                                                    body: {
                                                                      category:
                                                                        'db',
                                                                      tableName:
                                                                        'mediaUploadComments',
                                                                      primaryKey:
                                                                        String(
                                                                          listItemE.rootMessageID
                                                                        ),
                                                                      requestOperation:
                                                                        'update',
                                                                      updateExpression:
                                                                        'SET commentsReplyMapArray = :commentsReplyMapArray',
                                                                      expressionAttributeValues:
                                                                        {
                                                                          ':commentsReplyMapArray':
                                                                            replies
                                                                        }
                                                                    }
                                                                  }
                                                                ).then(
                                                                  () => {
                                                                    listItemE.likesArray =
                                                                      likesArray

                                                                    that.setState(
                                                                      {
                                                                        mediaMapArray:
                                                                          [
                                                                            ...that
                                                                              .state
                                                                              .mediaMapArray
                                                                          ]
                                                                      }
                                                                    )
                                                                  }
                                                                )
                                                              }
                                                            )
                                                          }}
                                                          style={{
                                                            border: 0,
                                                            background:
                                                              'transparent',
                                                            padding: 0,
                                                            marginTop: 4,
                                                            cursor:
                                                              'pointer',
                                                            color:
                                                              'rgba(204,12,12,1)',
                                                            fontSize: 11,
                                                          }}
                                                        >
                                                          <i
                                                            className={
                                                              listItemE.likesArray &&
                                                              listItemE.likesArray.includes(
                                                                currentUser.toLowerCase()
                                                              )
                                                                ? 'heart icon'
                                                                : 'heart outline icon'
                                                            }
                                                          />

                                                          {
                                                            listItemE.likesArray
                                                              ? listItemE
                                                                  .likesArray
                                                                  .length
                                                              : 0
                                                          }
                                                        </button>
                                                      </div>
                                                    </div>

                                                  )
                                                )
                                              }
                                            </div>
                                          :
                                            null
                                        }

                                      </div>
                                    </div>

                                  )
                                )
                              :
                                <div
                                  style={{
                                    padding: '15px 0',
                                    fontSize: 13,
                                    color:
                                      that.state.mode_light_dark ==
                                      'light'
                                        ? '#777777'
                                        : '#999999',
                                  }}
                                >
                                  {that.state.selectedLanguage ==
                                  'spanish'
                                    ? 'Aún no hay comentarios.'
                                    : 'No comments yet.'}
                                </div>
                            }

                          </div>
                        </div>

                      ))
                    :
                      <div
                        style={{
                          padding: '40px 20px',
                          textAlign: 'center',
                          color:
                            that.state.mode_light_dark == 'light'
                              ? '#666666'
                              : '#aaaaaa',
                        }}
                      >
                        {that.state.selectedLanguage == 'spanish'
                          ? 'No hay publicaciones todavía.'
                          : 'No posts yet.'}
                      </div>
                  }
                </div>
              </div>
            </Modal>

              
              
              
            <PasswordPrompt desktop
              open={that.state.showPasswordOverlay}
              theme={that.state.mode_light_dark}
              language={that.state.selectedLanguage}
              message={that.state.transactionConfirmationMessage}
              value={that.state.passwordText || ''}
              onChange={(event) => {
                          that.setState({
                            passwordText: event.target.value
                          })
                      }}
              onConfirm={() => {
                        that.setState({
                          showPasswordOverlay: false,
                          pendingTransactionLoaderOverlay: true,
                        })
                        if(that.state.moneyTransactionPreset == 'lend'){
                          that.contributeTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'withdraw'){
                          that.createWithdrawalReqTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'reclaim'){
                          that.rescindTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'stake'){
                          that.stakeTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'claimRewards'){
                          that.claimRewardsTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'repay'){
                          that.repayTxn(that.state.passwordText)
                        }
                      }}
              onCancel={() => {
                that.setState({
                  showPasswordOverlay: false,
                  passwordText: null,
                  passwordIsHiddenBool: true,
                })
              }}
            />

            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.generalNoticeTimedOverlay}
              // open={true}
              style={{
                width: '35vw',
                height: '15vh',
              }}
              // trigger={<Button>Show Modal</Button>}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
                
                
              <Modal.Content image>
                <Modal.Description>
                  <Header
                    style={{
                      left: '1vw',
                      marginRight: '1vw',
                      position: 'absolute',
                    }}
                  >{`${that.state.generalNoticeText}`}</Header>
                  
                </Modal.Description>
                
              </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.generalNoticeOverlay}
              // open={true}
              style={{
                width: '29vw',
                height: '25vh',
              }}
              // trigger={<Button>Show Modal</Button>}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
                
                
              <Modal.Content image>
                <Modal.Description>
                  <Header
                    style={{
                      left: '1vw',
                      marginRight: '1vw',
                      position: 'absolute',
                    }}
                  >{`${that.state.generalNoticeText}`}</Header>
                  <Button
                    content="Okay"
                    labelPosition='right'
                    icon='checkmark'
                    onClick={() => {
                      that.setState({
                        generalNoticeOverlay: false,
                      })
                    }}
                    positive
                    style={{
                      backgroundColor: 'rgba(0, 158, 129, 1)',
                      position: 'absolute',
                      bottom: 21,
                      width: '7vw',
                      left: '11vw',
                    }}
                  />
                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>



            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
                open={that.state.collateralIncreaseOverlay}
                // open={true}
                style={{
                  width: '29vw',
                  paddingLeft: '0.5vw',
                  paddingRight: '0.5vw',
                  height: '37vh',
                }}
              >
                <Modal.Header
                  style={{
                    paddingLeft: '7vh',
                  }}
                >
                  
                  The Blender Platform
                </Modal.Header>
                
                
                <Modal.Content image>
                
                  <Modal.Description>
                    <Header
                      style={{
                        left: '3vw',
                        paddingRight: '2vw',
                        position: 'absolute',
                        fontSize: 16,
                        textAlign: 'left',
                      }}
                    >

                      {that.state.selectedLanguage == 'spanish' ? 
                        'Aumenta el Límite de Crédito: '
                        :
                        'Increase Your Credit-Limit:'
                      }
                      {that.state.selectedLanguage == 'spanish' ? 
                        'el límite de crédito se aumenta igual al colateral puesto.'
                          :
                        'your Credit-Limit Increases\n1-to-1 with Added Collateral.'
                      }
                    </Header>
                    <div
                      style={{
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative',



                        height: '6vh',
                        width: '15vw',
                        marginTop: '9vh',
                        marginRight: '1vw',
                        marginLeft: '1vw',


                        left: 0, 
                        right: 0,
                        borderRadius: 3,
                        borderStyle: 'none',
                        borderColor: 'rgba(177, 177, 177, 0)',
                      }}
                    >

                      <input 
                        type='number'
                        autocomplete="off" 
                        onChangeText={(text) => {
                          that.setState({ collateralAssistanceRequestedUSD: text })
                        }}                    
                        value={that.state.collateralAssistanceRequestedUSD}
                        placeholder={ that.state.selectedLanguage == 'spanish' ? 'Colateral para Agregar' : `Collateral to Add` } 
                        
                        placeholderTextColor={that.state.isVerifiedRegistryAcceptedBool ? 'rgba(0, 158, 129, 1)' : 'rgba(0, 0, 0, 0.1)'}
                        keyboardType='numeric' 
                        editable={that.state.isVerifiedRegistryAcceptedBool}
                        style={{
                            fontWeight: '600',
                            fontFamily: 'arial',
                            color: 'rgba(0, 0, 0, 1)',
                            paddingLeft: '3vw',
                            paddingRight: '3vw',
                            textAlign: 'center',
                            textAlignVertical: 'center',
                            fontSize: 16,
                            height: 50,
                            width: '23vw',
                            borderWidth: 1,
                            backgroundColor: 'rgba(177, 177, 177, 0.5)',
                            borderStyle: 'solid',
                            borderColor: 'rgba(0, 158, 129, 0)',
                        }}
                      />
                      <p
                        style={{
                          zIndex: 990,
                          position: 'absolute',
                          marginTop: 0,
                          top: 15, 
                          left: '20vw',
                          backgroundColor: 'rgba(0, 158, 129, 0)',
                          fontSize: 15,
                          fontWeight: '600',
                          color: 'rgba(0, 0, 0, 1)',
                        }} 
                      >
                        {'USD'}
                      </p>
                    </div>
                    <div
                      style={{
                        flexDirection: 'row',
                        justifyContent: 'center',
                        // alignItems: 'center',
                        position: 'absolute',
                        bottom: 0, 
                        left: 0, 
                        right: 0,
                        width: '29vw',
                        // paddingLeft: 25,
                        // paddingRight: 25,
                      }}
                    >
                      
                      <Button
                        content={that.state.selectedLanguage == 'spanish' ? 
                          'Colateral Agregar'
                            :
                          'Add Collateral'
                        }
                        labelPosition='right'
                        icon='checkmark'
                        onClick={() => {
                          that.setState({
                            collateralIncreaseOverlay: false,
                            collateralToAddUSD: null,
                            actionValue: null
                          })
                        }}
                        positive
                        style={{
                          position: 'absolute',
                          right: '3vw',
                          bottom: 20,
                          // marginLeft: 25,
                          backgroundColor: 'rgba(0, 158, 129, 1)',
                        }}
                      />
                    

                      <Button className={"tbp-overlay-cancel"}
                        content="Cancel"
                        labelPosition='right'
                        icon='close'
                        onClick={() => {
                          that.setState({
                              collateralIncreaseOverlay: false,
                            })
                        }}
                        positive
                        style={{
                          position: 'absolute',
                          left: '3vw',
                          bottom: 20,
                          backgroundColor: 'rgba(204, 12, 12, 1)',
                        }}
                      />
                    </div>
                  </Modal.Description>
                
                  
                </Modal.Content>
            </Modal>


            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
                open={that.state.collateralRequestOverlay && that.state.allowsVerifiedRegistryCollateralInsurance}
                // open={true}
                style={{
                  width: '30vw',
                  height: '37vh',
                }}
                // trigger={<Button>Show Modal</Button>}
              >
                <Modal.Header
                  style={{
                    paddingLeft: '7vh',
                  }}
                >
                  
                  The Blender Platform
                </Modal.Header>
                
                
                <Modal.Content image>
              
                  <Modal.Description>
                    <Header
                      style={{
                        left: '3vw',
                        paddingRight: '3vw',
                        position: 'absolute',
                        fontSize: 17,
                        textAlign: 'left',
                      }}
                    >

                    {that.state.selectedLanguage == 'spanish' ? 
                        that.state.isVerifiedRegistryAcceptedBool 
                        ? 
                          'Estás aprobado para pedir asistencia de colateral; tu valor recibido por asistencia de colateral será pendiente a reseñar de Blender.\n\n'
                        : 
                          'Ha de llenar y entregar el formulario de Verified Registry y recibas confirmación de aprobación antes de pedir asistencia de colateral.\n\n'
                      :
                        that.state.isVerifiedRegistryAcceptedBool 
                        ? 
                          'You are Approved to Request Collateral Assistance; your received amount of Collateral Assistance is subject to Blender Review.\n\n'
                        : 
                          'You must complete the Verified Registry Application and receive acceptance confirmation to request Collateral Assistance.\n\n'
                    }
                    </Header>
                    <div
                      style={{
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative',

                        // backgroundColor: 'green',

                        height: '6vh',

                        width: '24vw',

                        marginLeft: '1.6vw',
                        
                        marginTop: '10vh',

                        // paddingLeft: '3vw',
                        // paddingRight: '3vw',

                        left: 0, 
                        right: 0,
                        borderWidth: 1,
                        borderRadius: 3,
                        borderStyle: 'none',
                        borderColor: 'rgba(177, 177, 177, 0)',
                      }}
                    >

                      <input 
                        autocomplete="off" 
                        onChangeText={(text) => {
                          that.setState({ collateralAssistanceRequestedUSD: text })
                        }}                    
                        value={that.state.collateralAssistanceRequestedUSD}
                        placeholder={ that.state.selectedLanguage == 'spanish' ? 'Límite de Crédito Pedido' : `Requested Credit Limit` } 
                        
                        placeholderTextColor={that.state.isVerifiedRegistryAcceptedBool ? 'rgba(0, 158, 129, 1)' : 'rgba(0, 0, 0, 0.1)'}
                        keyboardType='numeric' 
                        editable={that.state.isVerifiedRegistryAcceptedBool}
                        style={{
                            fontWeight: '600',
                            fontFamily: 'arial',
                            color: 'rgba(0, 0, 0, 1)',
                            paddingLeft: '3vw',
                            paddingRight: '3vw',
                            // marginLeft: '3vw', 
                            // marginRight: '3vw',
                            textAlign: 'center',
                            textAlignVertical: 'center',
                            fontSize: 15,
                            height: '6vh',
                            width: '24vw',
                            borderWidth: 1,
                            backgroundColor: 'rgba(177, 177, 177, 0.5)',
                            borderStyle: 'solid',
                            borderColor: 'rgba(0, 158, 129, 0)',
                        }}
                      />
                      <p
                        style={{
                          zIndex: 990,
                          position: 'absolute',
                          // marginTop: 30,
                          top: 17, 
                          right: 15,
                          backgroundColor: 'rgba(0, 158, 129, 0)',
                          fontSize: 15,
                          fontWeight: '600',
                          color: 'rgba(0, 0, 0, 1)',
                        }} 
                      >
                        {'USD'}
                      </p>
                    </div>
                    <div
                      style={{
                        flexDirection: 'row',
                        justifyContent: 'center', 
                        // alignItems: 'center',
                        position: 'absolute',
                        bottom: 0, 
                        left: 0, 
                        right: 0,
                        
                        // backgroundColor: 'red',
                        // width: '30vw',
                        // paddingLeft: 25,
                        // paddingRight: 25,
                      }}
                    >
                      {
                        // that.state.isVerifiedRegistryAcceptedBool 
                        false 
                        ? 
                        <Button
                          content={that.state.selectedLanguage == 'spanish' ? 
                            'Pedir Asistencia de Colateral'
                            :
                            'Request Collateral Assistance'
                          }
                          labelPosition='right'
                          icon='checkmark'
                          onClick={() => {
                            if(String(that.state.collateralAssistanceRequestedUSD).length > 0){
                              that.makeCollateralAssistanceRequest()
                            }
                          }}
                          positive
                          style={{
                            position: 'absolute',
                            right: '3vw',
                            bottom: 20,
                            // marginLeft: 25,
                            backgroundColor: 'rgba(0, 158, 129, 1)',
                          }}
                        />
                        :
                        <Button
                          content={that.state.selectedLanguage == 'spanish' ? 
                            'Empezar la Verificación'
                              :
                            'Begin Verified Registry App'
                          }
                          labelPosition='right'
                          icon='checkmark'
                          onClick={() => {
                            that.setState({
                              collateralRequestOverlay: false
                            })
                            
                          }}
                          positive
                          style={{
                            position: 'absolute',
                            right: '3vw',
                            bottom: 20,
                            // marginLeft: 25,
                            backgroundColor: 'rgba(0, 158, 129, 1)',
                          }}
                        />
                      }

                      <Button className={"tbp-overlay-cancel"}
                        content="Cancel"
                        labelPosition='right'
                        icon='close'
                        onClick={() => {
                          that.setState({
                            collateralRequestOverlay: false
                          })
                        }}
                        positive
                        style={{
                          position: 'absolute',
                          left: '3vw',
                          bottom: 20,
                          backgroundColor: 'rgba(204, 12, 12, 1)',
                        }}
                      />
                    </div>
                  </Modal.Description>
                
                  
                </Modal.Content>
            </Modal>



            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.renameCreditLineOverlay && !that.state.isSubscribedCurrentBool}
              // open={true}
              style={{
                width: '35vw',
              }}
              // trigger={<Button>Show Modal</Button>}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
                
              <Modal.Content image>
                  
                <div style={{
                  marginTop: 20,
                  height: 400,
                  width: '35vw',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}>
                  <p style = {{  
                    color: 'rgba(0, 0, 0, 1)',
                    fontSize: 40,
                    fontWeight: '600',
                    textAlign: 'center',
                    marginBottom: 0,
                    top: 5,
                  }}>
                    {that.state.selectedLanguage == 'spanish' ? 
                      'Suscríbase a '
                        :
                      'Subscribe to '
                    }
                    <p style = {{  
                      color: 'rgba(0, 158, 129, 1)',
                      fontSize: 40,
                      fontWeight: '600',
                      textAlign: 'center',
                      marginBottom: 0,
                      top: 5,
                    }}>
                      {'Blender Pro Plus'}
                    </p>
                  </p>
                  
                  <p style = {{  
                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(1, 1, 1, 1)',
                      fontSize: 20,
                      fontWeight: '600',
                      textAlign: 'center',
                      marginBottom: 75,
                      marginTop: 40,
                      marginBottom: 15,
                      marginLeft: 20, 
                      marginRight: 20,
                      textShadowColor: 'rgba(0, 0, 0, 0.10)',
                      textShadowOffset: {width: -1, height: 1},
                      textShadowRadius: 10, 
                  }}>
                    {that.state.selectedLanguage == 'spanish' ? 
                      'Exclusiva por Blender Pro Plus'
                        :
                      'Exclusive for Blender Pro Plus'
                    }
                  </p>
                
                  <div
                      style={{
                        marginTop: 15,
                        marginBottom: 0,
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        display: 'flex',
                    }}
                    >
                  
                      <Button 
                        onClick={() => {
                          
                          that.setState({
                            renameCreditLineOverlay: false,
                          })
                        }}
                        style={{
                            height: 65, 
                            width: '13vw', 
                            paddingLeft: 10, 
                            paddingRight: 10,  
                            borderRadius: 5, 
                            borderColor: 'rgba(0, 158, 129, 1)',
                            borderRadius: 5, 
                            backgroundColor: 'rgba(0, 158, 129, 1)',
                            marginBottom: 25,
                            marginTop: 25,
                            alignSelf: 'center',
                            alignContent: 'center',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                      >                  
                        <p style={{ fontSize: 20, textAlign: 'center', fontWeight: '600', color: 'rgba(256, 256, 256, 1)', }}> 
                          {that.state.selectedLanguage == 'spanish' ? 
                            'Blender Pro Plus'
                              :
                            'Blender Pro Plus'
                            }
                        </p>
                      </Button>
                      <Button 
                        onClick={() => {
                          that.setState({
                            renameCreditLineOverlay: false,
                          })
                        }}
                        style={{
                            height: 55, 
                            width: '10vw', 
                            paddingLeft: 10, 
                            paddingRight: 10,  
                            borderRadius: 5, 
                            borderColor: 'rgba(256, 256, 256, 1)',
                            borderRadius: 5, 
                            backgroundColor: 'rgba(0, 158, 129, 0.08)',
                            marginBottom: 25,
                            alignSelf: 'center',
                            alignContent: 'center',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                      >                  
                        <p style={{ fontSize: 16, textAlign: 'center', fontWeight: '600', color: 'rgba(0, 158, 129, 1)', }}> 
                          {that.state.selectedLanguage == 'spanish' ? 
                            'Cerrar'
                              :
                            'Close'
                          }
                        </p>
                      </Button>

                    </div>
                    
                </div>
                
              </Modal.Content>
            </Modal>
            
            

            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.statExplanationOverlay}
              // open={true}
              style={{
                width: '35vw',
                height: '40vh',
              }}
              // trigger={<Button>Show Modal</Button>}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
                            
              <Modal.Content image>
              
                <Modal.Description>
                  <Header
                    style={{
                      left: '1vw',
                      marginRight: '1vw',
                      position: 'absolute',
                      fontWeight: '600',
                    }}
                  >
                    <div
                      style={{
                        top: 0, 
                        display: 'flex',
                        flexDirection: 'column',
                        height: 30,
                        width: '27vw',
                        justifyContent: 'left',
                      }}
                    >
                      <p style = {{  
                        color: 'rgba(255, 255, 2550, 1)',
                        fontSize: 18,
                        fontWeight: '600',
                        textAlign: 'left',
                      }}>
                        {that.state.statName}
                      </p>
                      <p style = {{  
                        color: 'rgba(255, 255, 255, 1)',
                        fontSize: 16,
                        fontWeight: '600',
                        textAlign: 'left',
                        height: '5vh',
                        // backgroundColor: 'red',
                        // marginLeft: '3vw'
                      }}>
                        {that.state.statDesc}
                      </p>
                    </div>

                    <p style = {{  
                      color: 'rgba(0, 158, 129, 1)',
                      fontSize: 22,
                      fontWeight: '600',
                      textAlign: 'left',
                      marginBottom: 0,
                      marginTop: '10vh',
                      textShadowColor: 'rgba(0, 0, 0, 0.10)',
                      textShadowOffset: {width: -1, height: 1},
                      textShadowRadius: 10, 
                    }}>
                      {that.state.statValue}
                    </p>

                  </Header>
                  
                  <Button
                    content="Okay"
                    labelPosition='right'
                    icon='checkmark'
                    onClick={() => {
                      that.setState({
                        statExplanationOverlay: false,
                      })
                    }}
                    positive
                    style={{
                      backgroundColor: 'rgba(0, 158, 129, 1)',
                      position: 'absolute',
                      bottom: 21,
                      left: '14vw',
                      right: '14vw',
                      width: '7vw'
                    }}
                  />
                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>


            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.fundWalletPromptOverlay}
              // open={true}
              style={{
                width: '27vw',
                height: '25vh'
              }}
              // trigger={<Button>Show Modal</Button>}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
                
              <Modal.Content image>
                <Modal.Description>
                  <Header
                    style={{
                      left: '3vw',
                      marginTop: '1vh',
                      marginRight: '1vw',
                      position: 'absolute',
                    }}
                  >
                    <p style = {{  
                      color: 'rgba(0, 0, 0, 1)',
                      fontSize: 22,
                      fontWeight: '600',
                      textAlign: 'left',
                      textShadowColor: 'rgba(0, 0, 0, 0.10)',
                      textShadowOffset: {width: -1, height: 1},
                      textShadowRadius: 10, 
                    }}>
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Valor Bajo de Carter Blender\n\n'
                          :
                        'Low Blender Wallet Balance\n\n'
                      }
                      <p style = {{  
                        color: 'rgba(0, 158, 129, 1)',
                        fontSize: 18,
                        fontWeight: '600',
                        textAlign: 'left',
                      }}>
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Querias depositar\npor su tarjeta de banco?'
                            :
                          'Would you like to top-up\nusing your debit card?'
                        }
                      </p>
                  
                    </p>
                  </Header>




                  <div
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'center', 
                      // alignItems: 'center',
                      position: 'absolute',
                      bottom: 0, 
                      left: 0, 
                      right: 0,
                      
                      // backgroundColor: 'red',
                      // width: '30vw',
                      // paddingLeft: 25,
                      // paddingRight: 25,
                    }}
                  >
                  
                    <Button
                      content={that.state.selectedLanguage == 'spanish' ? 
                        'Depositar Fondos'
                          :
                        'Deposit Funds'
                      }
                      labelPosition='right'
                      icon='checkmark'
                      onClick={() => {
                        that.setState({
                          fundWalletPromptOverlay: false,
                          inProcessLoading: true,
                        })
                      }}
                      positive
                      style={{
                        position: 'absolute',
                        right: '3vw',
                        bottom: 20,
                        color: 'rgba(255, 255, 255, 1)',
                        // marginLeft: 25,
                        backgroundColor: 'rgba(0, 158, 129, 1)',
                      }}
                    />
                    <Button
                      content={that.state.selectedLanguage == 'spanish' ? 
                        'No'
                          :
                        'No'
                      }
                      labelPosition='right'
                      icon='close'
                      onClick={() => {
                        that.setState({
                          fundWalletPromptOverlay: false,
                        })
                      }}
                      positive
                      style={{
                        position: 'absolute',
                        left: '3vw',
                        bottom: 20,
                        color: 'rgba(255, 255, 255, 1)',
                        backgroundColor: 'rgba(204, 12, 12, 1)',
                      }}
                    />
                  </div>

                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.activityIndicator ? true : false}
              // open={true}
              style={{
                width: '27vw',
              }}
              // trigger={<Button>Show Modal</Button>}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
                
              {/* <Modal.Content image>
                <Modal.Description> */}
                  <div
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginLeft: '6vw',
                      marginRight: '8vw',
                      marginTop: '2.5vw',
                      marginBottom: '2.5vw',
                      // width: 'vw',
                      // backgroundColor: 'red'
                    }}
                  >
                    {/* {that.state.activityIndicator} */}
                    <div className="tbp-overlay-loading"><ThreeDot 
                      color="rgba(0, 158, 129, 1)" 
                      size="large" 
                      style={{
                        // width: 200,
                        speedPlus: -2,
                        // position: 'absolute',
                        left: '3vw',
                        marginLeft: '3vw',
                      }}
                    /></div>
                  </div>
                  
                {/* </Modal.Description>
                
              </Modal.Content> */}
            </Modal>

            <Modal
              centered={true}
              dimmer={{ className: "tbp-overlay-backdrop" }}
              className={"tbp-desktop-modal tbp-overlay tbp-borrow-page-loader " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.showPageLoader}
              style={{
                width: 'min(720px, 88vw)',
                maxWidth: 720,
                height: 'auto',
                minHeight: 0,
                maxHeight: '82vh',
                overflowY: 'auto',
                overflowX: 'hidden',
                padding: 0,
                margin: '0 auto',
                borderRadius: 18,
                boxSizing: 'border-box',
                backgroundColor: that.state.mode_light_dark == 'light'
                  ? 'rgba(255, 255, 255, 0.98)'
                  : 'rgba(31, 31, 33, 0.98)',
                color: that.state.mode_light_dark == 'light'
                  ? '#171717'
                  : '#ffffff',
                border: '1px solid #3b526c',
                boxShadow: '0 18px 60px rgba(0, 0, 0, 0.40)'
              }}
            >
              <Modal.Content
                style={{
                  padding: 0,
                  backgroundColor: 'transparent'
                }}
              >
                <div
                  style={{
                    padding: '28px 34px 30px',
                    boxSizing: 'border-box'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 14,
                      marginBottom: 24
                    }}
                  >

                    <div className="tbp-borrow-loader-title"
                      style={{
                        fontSize: 27,
                        fontWeight: '700',
                        color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                        textAlign: 'center'
                      }}
                    >
                      {that.state.selectedLanguage == 'spanish'
                        ? 'Explora The Blender Platform'
                        : 'Explore The Blender Platform'}
                    </div>
                  </div>

                  <div className="tbp-borrow-loader-subtitle"
                    style={{
                      textAlign: 'center',
                      fontSize: 17,
                      fontWeight: '600',
                      marginBottom: 28,
                      color: that.state.mode_light_dark == 'light'
                        ? 'rgba(55, 55, 55, 1)'
                        : 'rgba(220, 220, 220, 1)'
                    }}
                  >
                    {that.state.selectedLanguage == 'spanish'
                      ? 'Presta • Pide Prestado • Apuesta'
                      : 'Lend • Borrow • Stake'}
                  </div>

                  <div className="tbp-borrow-loader-info"
                    style={{
                      borderRadius: 16,
                      border: '1px solid #3b526c',
                      backgroundColor: that.state.mode_light_dark == 'light'
                        ? '#f0f6fb'
                        : '#1b3046',
                      padding: '22px 24px',
                      boxSizing: 'border-box'
                    }}
                  >
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr',
                        gap: 0
                      }}
                    >
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '54px 1fr',
                          gap: 16,
                          alignItems: 'start',
                          paddingBottom: 20
                        }}
                      >
                        <div
                          style={{
                            width: 48,
                            height: 48,
                            minWidth: 48,
                            minHeight: 48,
                            flexShrink: 0,
                            borderRadius: 24,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(0, 158, 129, 0)',
                            color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                            fontSize: 24,
                            fontWeight: '700'
                          }}
                        >
                          <i className="chart line icon" />
                        </div>

                        <div>
                          <div
                            style={{
                              color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                              fontSize: 18,
                              fontWeight: '700',
                              marginBottom: 6
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish' ? 'PRESTAR' : 'LEND'}
                          </div>

                          <div
                            style={{
                              color: that.state.mode_light_dark == 'light'
                                ? '#222222'
                                : '#eeeeee',
                              fontSize: 15,
                              lineHeight: 1.55,
                              fontWeight: '500'
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish'
                              ? 'Compara tasas de interés, actividad y estadísticas de pago antes de elegir una línea de crédito. Los fondos aún no retirados pueden seguir siendo reclamables.'
                              : 'Compare interest rates, activity and repayment statistics before choosing a credit-line. Funds not yet withdrawn may remain reclaimable.'}
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          height: 1,
                          backgroundColor: that.state.mode_light_dark == 'light'
                            ? 'rgba(0, 0, 0, 0.08)'
                            : 'rgba(255, 255, 255, 0.10)',
                          marginBottom: 20
                        }}
                      />

                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '54px 1fr',
                          gap: 16,
                          alignItems: 'start',
                          paddingBottom: 20
                        }}
                      >
                        <div
                          style={{
                            width: 48,
                            height: 48,
                            minWidth: 48,
                            minHeight: 48,
                            flexShrink: 0,
                            borderRadius: 24,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(0, 158, 129, 0)',
                            color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                            fontSize: 21,
                            fontWeight: '700'
                          }}
                        >
                          <i className="credit card outline icon" />
                        </div>

                        <div>
                          <div
                            style={{
                              color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                              fontSize: 18,
                              fontWeight: '700',
                              marginBottom: 6
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish'
                              ? 'PEDIR PRESTADO'
                              : 'BORROW'}
                          </div>

                          <div
                            style={{
                              color: that.state.mode_light_dark == 'light'
                                ? '#222222'
                                : '#eeeeee',
                              fontSize: 15,
                              lineHeight: 1.55,
                              fontWeight: '500'
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish'
                              ? 'Tu crédito disponible depende de los fondos aportados y el colateral de tu línea. Retira crédito disponible y repaga deuda desde tu Blender Wallet.'
                              : 'Your available credit depends on contributed funds and collateral in your line. Withdraw available credit and repay debt from your Blender Wallet.'}
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          height: 1,
                          backgroundColor: that.state.mode_light_dark == 'light'
                            ? 'rgba(0, 0, 0, 0.08)'
                            : 'rgba(255, 255, 255, 0.10)',
                          marginBottom: 20
                        }}
                      />

                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '54px 1fr',
                          gap: 16,
                          alignItems: 'start'
                        }}
                      >
                        <div
                          style={{
                            width: 48,
                            height: 48,
                            minWidth: 48,
                            minHeight: 48,
                            flexShrink: 0,
                            borderRadius: 24,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(0, 158, 129, 0)',
                            color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                            fontSize: 22,
                            fontWeight: '700'
                          }}
                        >
                          <i className="shield alternate icon" />
                        </div>

                        <div>
                          <div
                            style={{
                              color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                              fontSize: 18,
                              fontWeight: '700',
                              marginBottom: 6
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish'
                              ? 'APOSTAR'
                              : 'STAKE'}
                          </div>

                          <div
                            style={{
                              color: that.state.mode_light_dark == 'light'
                                ? '#222222'
                                : '#eeeeee',
                              fontSize: 15,
                              lineHeight: 1.55,
                              fontWeight: '500'
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish'
                              ? 'Aporta colateral a una línea de crédito y recibe comisiones elegibles generadas por la actividad procesada en esa línea.'
                              : 'Provide collateral to a credit-line and receive eligible commissions generated by activity processed through that line.'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="tbp-borrow-loader-tip"
                    style={{
                      marginTop: 20,
                      padding: '16px 20px',
                      borderRadius: 14,
                      border: '1px solid #3b526c',
                      backgroundColor: that.state.mode_light_dark == 'light'
                        ? '#f0f6fb'
                        : '#1b3046',
                      textAlign: 'center'
                    }}
                  >
                    <div
                      style={{
                        color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                        fontSize: 14,
                        fontWeight: '700',
                        marginBottom: 6
                      }}
                    >
                      {that.state.selectedLanguage == 'spanish'
                        ? '¿SABÍAS QUE?'
                        : 'DID YOU KNOW?'}
                    </div>

                    <div
                      style={{
                        color: that.state.mode_light_dark == 'light'
                          ? '#2a2a2a'
                          : '#e5e5e5',
                        fontSize: 14,
                        lineHeight: 1.5,
                        fontWeight: '500'
                      }}
                    >
                      {that.state.selectedLanguage == 'spanish'
                        ? 'Puedes revisar la actividad, deuda, tasas y estadísticas de una línea de crédito antes de prestar o apostar fondos.'
                        : 'You can review activity, debt, rates and credit-line statistics before deciding whether to lend or stake funds.'}
                    </div>
                  </div>

                  <div
                    style={{
                      marginTop: 18,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: 10,
                      color: (that.state.mode_light_dark === 'light' ? '#008f76' : '#24cba7'),
                      fontSize: 15,
                      fontWeight: '700'
                    }}
                  >
                    <div
                      style={{
                        width: 18,
                        height: 18,
                        borderRadius: '50%',
                        border: '2px solid #3b526c',
                        borderTopColor: '#24cba7',
                        animation: 'tbpSpin 0.9s linear infinite'
                      }}
                    />

                    {that.state.selectedLanguage == 'spanish'
                      ? 'Cargando Línea de Crédito'
                      : 'Loading Credit-Line'}
                  </div>

                  <style>
                    {`
                      @keyframes tbpSpin {
                        from { transform: rotate(0deg); }
                        to { transform: rotate(360deg); }
                      }
                    `}
                  </style>
                </div>
              </Modal.Content>
            </Modal>
            


              <div className="tbp-platform__sidebar" style={{
                // borderRadius: 10,
                justifyContent: 'center',
                alignItems: 'center',
                width: '13vw',
                height: '100vh',
                margin: 0,
                left: 0,
                position: 'absolute',
                borderRightStyle: 'solid',
                borderWidth: 0.1,
                borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              }}>
                <Button
                  onClick={() => {
                    that.setState({
                      navigationDestinationObject: {
                          navigationRoute: '/home',
                      },
                    })
                  }}
                  style={{
                    position: 'relative',
                    left: '2vw',
                    top: '1vw',
                    height: '5vw',
                    width: '5vw',
                    marginBottom: '2vh',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                  }}
                >
                  <img 
                    // className="logoImage" 
                    src="https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png"
                    style={{
                      height: '4vw',
                      width: '4vw',
                      position: 'absolute',
                      top: 7, 
                      left: 3, 
                      right: 0,
                      borderRadius: 7,
                      borderStyle: 'solid',
                      borderWidth: 0.1,
                      borderColor: 'rgba(177, 177, 177, 0.1)',
                    }}
                  />
                </Button>


                <List>
                  <ListItem
                    style={{
                      marginBottom: 10,

                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      className="ui huge teal button"
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/home',
                          },
                        })
                      }}
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="home icon"/>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Activos'
                            :
                          'Accounts'
                        }
                      </p>
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/browser',
                          },
                        })
                      }}
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      className="ui huge teal button"
                      
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="search icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Buscar'
                            :
                          'Browse'
                        }
                      </p>
                      
                    </button>
                  </ListItem>

                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/newborrowingacct',
                          },
                        })
                      }}
                      className="ui huge teal button"
                        
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="newspaper icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Tomar Prestamo'
                            :
                          'Borrow Funds'
                        }
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/membertransactions',
                          },
                        })
                      }}
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      className="ui huge teal button"
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="wait icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Transacciones'
                            :
                          'Transactions'
                        }
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/SubscriptionPlan',
                          },
                        })
                      }}
                      className="ui huge teal button"
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="star icon"></i>
                        &nbsp;  
                        {'Blender Pro Plus'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      onClick={() => {
                        var win = window.open('https://lenderblockcorp.com/termsandconditions-tbp', '_blank');
                        win.focus();
                      }}
                      className="ui huge teal button"
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="book icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Condiciones'
                            :
                          'Terms of Use'
                        }
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      onClick={() => {
                        var win = window.open('https://lenderblockcorp.com/privacypolicy-tbp', '_blank');
                        win.focus();
                      }}
                      className="ui huge teal button"
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="book icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Privacidad'
                            :
                          'Privacy Policy'
                        }
                      </p>
                      
                    </button>
                  </ListItem>
                </List>




                <button 
                  
                  style={{
                    position: 'fixed',
                    bottom: 20,
                    marginBottom: 10,
                    marginLeft: 25,
                    borderRadius: 20,
                    backgroundColor: 'rgba(0, 158, 129, 0)',
                    borderWidth: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 15,
                  }}
                  onClick={() => { 
                    trackPageRequest(Auth.signOut())
                    that.setState({
                      navigationDestinationObject: {
                          navigationRoute: '/welcome',
                      },
                    }) 
                  }}
                  className="ui medium teal button"
                >
                  <p
                    style={{
                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                    }}
                  >
                    <i className="sign out icon"/>
                    {that.state.selectedLanguage == 'spanish' ? 
                      'Desconectar'
                        :
                      'Sign Out'
                    }
                  </p>
                </button>
              </div>

              <div className="tbp-platform__workspace" style={{
                // backgroundColor: 'blue',
                // borderRadius: 10, 
                justifyContent: 'center',
                alignItems: 'center',
                width: '87vw',
                height: '100vh',
                margin: 0,
                flexDirection: 'column',
                // borderStyle: 'none',
                borderWidth: 0,    
                position: 'absolute',
                left: '13vw',
                top: '0vh',
                backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
                // border: 'none',   
                // borderColor: 'rgba(177, 177, 177, 0)',
              }}>
              
                <div className="tbp-platform__topbar" style={{
                  // backgroundColor: 'rgba(0, 158, 129, 0)',
                  // borderRadius: 10,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '87vw',
                  height: '7vh',
                  paddingLeft: '3vw',
                  margin: 0,
                  display: 'flex',
                  flexDirection: 'row',
                  paddingRight: '10vw',
                  borderBottomStyle: 'solid',
                  borderWidth: 0.1,
                  borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                  backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
                }}>
                  <p 
                    style={{ 
                      textAlign: 'left',
                      textAlignVertical: 'center',
                      fontSize: 23, 
                      fontWeight: '600', 
                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                      marginTop: 30, 
                      marginBottom: 30,
                      // textUnderlineOffset: 3, 
                      // textDecorationLine: 'underline', 
                      // textDecorationColor: 'rgba(255, 255, 255, 1)',
                    }}
                  >
                      <span className="tbp-platform__eyebrow">THE BLENDER PLATFORM</span><span className="tbp-platform__title">{that.state.selectedLanguage === 'spanish' ? "Línea de crédito" : "Credit line"}</span>  
                  </p>


                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      position: 'absolute',
                      right: 0,
                      padding: 10,
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      paddingRight: 25,
                      borderRadius: 17
                    }}
                  >
                    <Button
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/accountmanagement',
                          },
                        })
                      }}
                      style={{
                        borderBottomLeftRadius: 18,
                        borderBottomRightRadius: 5,
                        borderTopLeftRadius: 18,
                        borderTopRightRadius: 5,
                        height: '40px',
                        borderWidth: 2,
                        marginLeft: 25,
                        marginRight: 10,
                        backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(35, 35, 35, 1)', 
                        borderColor: 'rgba(224, 225, 226, 0)',
                        borderStyle: 'solid', 
                        justifyContent: 'center', 
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'row',
                        transitionDuration: '0.4s',
                        cursor: 'pointer',
                        padding: 0,
                      }}
                    >
                      <img 
                        className="header_profileImage" 
                        width="35" 
                        height="35" 
                        src={that.state.currentUserProfilePicture}
                      />

                      <p 
                        style={{ 
                          textAlign: 'right',
                          textAlignVertical: 'center',
                          fontSize: 16, 
                          fontWeight: '600', 
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                          marginLeft: 12, 
                          marginRight: 15,
                          marginTop: 5,
                          // textUnderlineOffset: 3, 
                          // textDecorationLine: 'underline', 
                          // textDecorationColor: 'rgba(255, 255, 255, 1)',
                        }}
                      >
                          {String(that.state.currentUser).toUpperCase()}
                      </p>
                    </Button>
                  </div>


  
                  <div
                    style={{
                      display: 'flex',
                      position: 'absolute',
                      right: 200,
                      width: '5vw',
                      height: '7vh',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <button
                      type="button"
                      aria-label={that.state.mode_light_dark === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
                      onClick={() => switchPlatformTheme({ that, authenticatedPut, currentUser })}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 44,
                        height: 44,
                        padding: 0,
                        margin: 0,
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer'
                      }}
                    >
                      <i
                        aria-hidden="true"
                        className={that.state.mode_light_dark === 'dark' ? 'sun icon' : 'moon icon'}
                        style={{
                          display: 'block',
                          fontSize: 32,
                          lineHeight: 1,
                          margin: 0,
                          color: that.state.mode_light_dark === 'light' ? '#000000' : '#ffffff'
                        }}
                      />
                    </button>
                  </div>

                </div>

                <div className="tbp-platform__body" style={{
                  // backgroundColor: 'blue',
                  // borderRadius: 10,
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '87vw',
                  height: '93vh',
                  margin: 0,
                  borderStyle: 'none',
                  borderWidth: 0,
                }}>
                  <div
                    class="scrollNoScrollBar"
                    style={{
                      // borderRadius: 10,
                      // backgroundColor: 'red',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '62vw',
                      position: 'fixed',
                      left: '13vw',
                      // top: 0, 
                      // bottom: 0, 
                      height: '93vh',
                      marginTop: 0,
                      marginBottom: 0,
                      marginRight: 0,
                      marginLeft: '0vw',
                      borderStyle: 'none',
                      borderWidth: 0,
                      scrollbarWidth: 'none',
                      overflowY: 'auto',
                      overflowX: 'hidden'
                    }}
                  >



                      <div
                        style={{
                          width: '62vw',
                          height: '10vh',
                          flexDirection: 'row',
                          display: 'flex',
                          paddingLeft: '3vw',
                          paddingTop: '4vh',
                          paddingBottom: '0px',
                          paddingRight: '7vw',
                          borderRadius: 3,
                          borderColor: 'rgba(177, 177, 177, 1)',
                          justifyContent: 'space-between',
                        }}
                      >
                        <p
                          style={{
                            fontSize: 25, 
                            textAlign: 'left',
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                          }}
                        >


                          
                          {String(that.state.managerDisplayName).toLowerCase() != String(that.state.managerUsername).toLowerCase() ? String(that.state.managerDisplayName).toUpperCase() : String(that.state.managerUsername).toUpperCase()}
                          {
                            that.state.managerFullName
                            ?
                            <p style = {{  
                              fontSize: 19, 
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              textAlign: 'left',
                            }}>
                              {String(that.state.managerDisplayName).toLowerCase() != String(that.state.managerUsername).toLowerCase() ? String(that.state.managerUsername).toUpperCase() : String(that.state.managerFullName)}
                              &nbsp; &nbsp; 
                              {String(that.state.managerDisplayName).toLowerCase() != String(that.state.managerUsername).toLowerCase() ? '(' : null} 
                              {String(that.state.managerDisplayName).toLowerCase() != String(that.state.managerUsername).toLowerCase() ? String(that.state.managerFullName) : null} 
                              {String(that.state.managerDisplayName).toLowerCase() != String(that.state.managerUsername).toLowerCase() ? ')' : null} 
                            </p>
                            : 
                            null
                          }

                        </p>

                        <Button
                          style={{
                            width: 76,
                            height: 76,
                            right: -30,
                            top: 0,
                            // position: 'absolute',
                            padding: 1,
                            borderRadius: 38, 
                            zIndex: 99999,
                            borderWidth: 1,
                            backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)',
                            borderColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.3)' : 'rgba(177, 177, 177, 1)',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                          onClick={() => {
                            that.setState({
                              socialOverlay: true
                            })
                          }}
                        >
                          <img 
                            className="header_profileImage" 
                            style={{
                              width: 74,
                              height: 74,
                              borderRadius: 37, 
                              borderWidth: 2,
                              borderColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.3)' : 'rgba(177, 177, 177, 1)',
                              justifyContent: 'center',
                              alignItems: 'center',
                              top: 0, 
                              bottom: 0,
                              left: 0, 
                              right: 0, 
                              // marginTop: 0,
                              // width: WIDTH,
                              // justifyContent: 'center',
                              // position: 'position',
                              // top: 0,
                              // zIndex: 999,  
                            }}
                            src={that.state.socialOverlayData_imageURI}
                          />
                          
                        </Button>
                      </div>

                      
                      <div
                        style={{
                          width: '62vw',
                          height: '10vh',
                          flexDirection: 'row',
                          display: 'flex',
                          padding: '3vw',
                          paddingRight: '7vw',
                          borderRadius: 3,
                          borderColor: 'rgba(177, 177, 177, 1)',
                          justifyContent: 'space-between',
                          // backgroundColor: 'red',
                        }}
                      >
                        
                        <p
                          style={{
                            fontSize: 25, 
                            textAlign: 'left',
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                          }}
                        >
                          <p
                            style={{
                              fontSize: 18, 
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              textAlign: 'left',
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish' ? 
                              'Límite de Crédito:  '
                            :
                              'Credit Limit:  '
                            }
                          </p>
                          {formatCreditCardUSD(realCreditLimit)}
                        </p>
                        <p
                          style={{
                            fontSize: 25, 
                            textAlign: 'left',
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                          }}
                        >
                          <p
                            style={{
                              fontSize: 18, 
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              textAlign: 'left',
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish' ? 
                              'Crédito Disponible:  '
                            :
                              'Available Credit:  '
                            }
                          </p>
                          {formatCreditCardUSD(liquidAvailableCredit)}
                        
                        </p>
                        <p
                          style={{
                            fontSize: 25, 
                            textAlign: 'left',
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                          }}
                        >
                          <p
                            style={{
                              fontSize: 18, 
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              textAlign: 'left',
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish' ? 
                              'Tasa de Interés Anual  '
                                :
                              'Annual Interest Rate:  '
                            }
                          </p>
                          {Number(that.state._intRate).toFixed(0) + ' %'}
                        </p>
                      </div>










                                          
                      <div 
                        style={{ 
                          // backgroundColor: 'red',
                          zIndex: 2, 
                          position: 'relative', 
                          marginTop: '5vh', 
                          height: 500,
                          width: '62vw', 
                          padding: '3vw', 
                          zIndex: 999999, 
                          paddingTop: 20 
                        }}
                      >
                        <div
                          style={{
                            top: -7,
                            height: 50,
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            paddingRight: '9vw',
                            width: '62vw',
                            display: 'flex',
                            flexDirection: 'row',
                          }}
                        >
                          <p style = {{  
                            color: 'rgba(0, 158, 129, 1)',
                            fontSize: 24,
                            // fontWeight: '400',
                            textAlign: 'left',
                            textAlignVertical: 'center',
                            // left: 20,
                            // top: -7,
                            // position: 'absolute',
                            textShadowColor: 'rgba(0, 0, 0, 0.1)',
                            textShadowOffset: {width: -1, height: 1},
                            textShadowRadius: 10, 
                          }}>
                            {that.state.selectedLanguage == 'spanish' ? 
                              'Suma de Contribuciones (USD)  '
                                :
                              'Lender Pool Sum (USD)  '
                            }
                          </p>
                          <Button
                            style={{
                              // right: '3vw',
                              // top: -7,
                              // position: 'absolute',
                              fontWeight: '500',
                              justifyContent: 'center',
                              alignItems: 'center',
                              backgroundColor: 'rgba(0, 0, 0, 0.05)',
                              borderRadius: 3, 
                              height: 35,
                              marginBottom: 15,
                              paddingTop: 0,
                              paddingBottom: 0,
                              paddingLeft: 15,
                              paddingRight: 15,

                            }}
                            onClick={() => {
                              that.changeChartDayRange()
                            }}
                            disabled={that.state.disableChangeChartDayRange}
                          >
                            <p style = {{  
                              color: 'rgba(0, 158, 129, 1)',
                              fontSize: 14,
                              fontWeight: '500',
                              textAlign: 'center',
                              // marginTop: 1, 
                              position: 'relative',
                              top: 0, 
                              bottom: 0,
                              textAlignVertical: 'center',
                              textShadowColor: 'rgba(0, 0, 0, 0.1)',
                              textShadowOffset: {width: -1, height: 1},
                              textShadowRadius: 10, 
                            }}>
                              {that.state.timePeriodString}
                            </p>
                          </Button>
                        </div>


                        {
                          that.state._values.length >= 30
                          ?
                          <ResponsiveContainer 
                            width="100%" 
                            height={350}
                            style={{
                              borderColor: 'rgba(0, 0, 0, 0)',
                              // borderColor: 'rgba(0, 158, 129, 1)',
                              borderStyle: 'solid',
                              borderWidth: 1,
                              marginBottom: '7vw',
                            }}
                          >
                            <LineChart 
                              width="100%" 
                              height="100%" 
                              data={that.state._values} 
                              margin={{ 
                                top: 5, 
                                right: 20, 
                                bottom: 5 
                              }}
                            >
                              {/* <Legend /> */}
                              <XAxis 
                                dataKey="name"
                                // hide={true}
                                tickCount={3}
                                minTickGap={25}
                                tick={(payload) => {

                                  if (payload) {
                                    return (
                                      <g transform={`translate(${payload.x},${payload.y})`}>
                                        <text 
                                          x={110} 
                                          y={0} 
                                          dy={16}
                                          textAnchor="end" 
                                          fill="#666" 
                                          // transform="rotate(-35)"
                                          style={{
                                            fontSize: 16,
                                            textAlign: 'right',
                                          }}
                                        >
                                          {String(payload.payload.value)}
                                        </text>
                                      </g>
                                    )
                                  } 

                                }}
                                interval={Math.floor(that.state._values.length/4)}
                                // interval={'preserveEnd'}

                              />
                              <YAxis 
                                // stroke={'#282c34'}
                                tickCount={3}
                              />
                              <Tooltip
                                active={true}
                                cursor={{ stroke: that.state.mode_light_dark === 'light' ? '#128d78' : '#24d5b4', strokeDasharray: '3 4', strokeWidth: 1 }}
                                wrapperStyle={{ outline: 'none', zIndex: 30, pointerEvents: 'none' }}
                                content={({ active, payload, label }) => {
                                  if (!active || !payload || !payload.length) return null;
                                  const pointValue = Number(payload[0].value);
                                  return (
                                    <div className={"tbp-credit-chart-tooltip " + (that.state.mode_light_dark === 'light' ? 'light' : 'dark')} role="status">
                                      <span className="tbp-credit-chart-tooltip__date">{String(label ?? '')}</span>
                                      <strong className="tbp-credit-chart-tooltip__value">{Number.isFinite(pointValue) ? pointValue.toFixed(2) : '—'} <span>USD</span></strong>
                                    </div>
                                  );
                                }}
                              />
                              {/* <CartesianGrid strokeDasharray="3 3" /> */}
                              <Line 
                                activeDot={{ r: 4 }}
                                dot={false}
                                type="monotone" 
                                dataKey="availableCredit" 
                                stroke="#009e81" 
                                onMouseMove={() => {
                                }}
                              />
                            </LineChart>
                          </ResponsiveContainer>
                          :
                          null
                        }

                      </div>


        






                        <div 
                          style={{ 
                            zIndex: 99999, 
                            position: 'relative', 
                            marginTop: '0vh', 
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'top',
                            width: '62vw', 
                            height: 800,
                            marginRight: '2vw', 
                            paddingRight: '3vw', 
                            // backgroundColor: 'blue'
                          }}  
                        >




                          <div style={{ zIndex: 2, position: 'relative', top: 0, width: '27vw', paddingRight: '3vw', paddingLeft: '3vw', paddingTop: '0vh', }} >
                            <div
                              style={{
                                width: '27vw',
                                height: '10vh',
                                flexDirection: 'row',
                                display: 'flex',
                                paddingLeft: '0vw',
                                paddingTop: '4vh',
                                paddingBottom: '0px',
                                paddingRight: '7vw',
                                borderRadius: 3,
                                borderColor: 'rgba(177, 177, 177, 1)',
                                justifyContent: 'space-between',

                              }}
                            >
                              <p
                                style={{
                                  fontSize: 25, 
                                  textAlign: 'left',
                                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                  
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: 25, 
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                    textAlign: 'left',
                                  }}
                                >
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    "Estadísticas de Cuenta"
                                      :
                                    "Account Stats"
                                  }
                                </p>
                              </p>
                            </div>
                            <div
                              style={{
                                width: '27vw',
                                height: '50px',
                                paddingLeft: '0vw',
                                paddingRight: '5vw',
                                paddingTop: '0vh',
                                borderRadius: 3,
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginBottom: '4vh',
                              }}
                            >
                              <React.Fragment>
                                  {that.state.accountStatsArray.map(listItem => (
                                  
                                        
                                      <Button 
                                        onClick={() => {
                                          that.setState({
                                            statDesc: listItem.statDesc,
                                            statName: listItem.statName,
                                            statValue: listItem.statValue,
                                            statColor: listItem.statColor,
                                            statExplanationOverlay: true,
                                          })
                                        }}
                                        disabled={listItem.disabled}
                                        style={{
                                          borderWidth: 0,
                                          display: 'flex',
                                          paddingLeft: 0,
                                          width: '24.3vw',
                                          height: '60px',
                                          paddingRight: 0,
                                          flexDirection: "row",
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                          backgroundColor: 'rgba(255, 255, 255, 0)',
                                        }}
                                      >

                                            
                                            <p style={{ 
                                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',  
                                                fontSize: 17,
                                                                                                lineHeight: '22px',
                                                marginTop: 0,
                                                marginBottom: 0,
                                                paddingTop: 0,
                                                paddingBottom: 0,
justifyContent: 'center',
                                                textAlign: 'center', 
                                                position: 'relative',
                                                textAlignVertical: 'center',
                                                bottom: 0,
                                                fontWeight: '500',
                                            }}> 
                                                {listItem.statName}
                                            </p>
                                            <p style={{  
                                                color: 'rgba(0, 158, 129, 1)',
                                                fontSize: 17,
                                                                                                lineHeight: '22px',
                                                marginTop: 0,
                                                marginBottom: 0,
                                                paddingTop: 0,
                                                paddingBottom: 0,
justifyContent: 'center',
                                                position: 'relative',
                                                textAlign: 'center', 
                                                textAlignVertical: 'center',
                                                bottom: 0,
                                                fontWeight: '500',
                                            }}> 
                                                {listItem.statValue}{' '}
                                                {
                                                // listItem.statName == 'Blender Score' ?
                                                    // <Icon1 name={'ios-ribbon'} size={14} style={{
                                                    //     position: 'absolute',
                                                    //     bottom: 0,
                                                    //     right: 27,
                                                    //     marginBottom: 40,  
                                                    //     color: 'rgba(0, 158, 129, 1)',
                                                    //     paddingBottom: 15,
                                                    // }}/> :
                                                    // null
                                                }
                                            </p>
                                    
                                      </Button>


                                  ))}
                              </React.Fragment>
                            </div>
                          </div>




                        </div>



                        

                        <PlatformFooter language={that.state.selectedLanguage} />

                  </div>

                  <div className="tbp-money-rail" style={{
                    // backgroundColor: 'red',
                    // borderRadius: 10,
                    alignItems: 'center',
                    width: '25vw',
                    position: 'fixed',
                    right: 0,
                    // top: 0, 
                    // bottom: 0, 
                    height: '93vh',
                    marginTop: 0,
                    marginBottom: 0,
                    marginRight: 0,
                    marginLeft: '65vw',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderLeftStyle: 'solid',
                    borderWidth: 0.1,
                    borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                  }}>






                    <div className="tbp-txn-form"
                      style={{
                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                  fontFamily: 'Lato, Arial, sans-serif',

                        marginBottom: 25,
                        height: '50vh',
                        marginTop: 0,
                        width: '25vw',
                        borderRadius: 5,
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: 14, 
                        fontWeight: '600',
                      }}
                      // disabled={true}
                    >

                      <section className="tbp-wallet-balance-slot"><AvailableWalletBalance balanceWei={that.state.walletBalanceWeiUSD} language={that.state.selectedLanguage} theme={that.state.mode_light_dark} context="borrowing" /></section>

                      {
                        String(that.state.managerUsername).toLowerCase() != String(that.state.currentUser).toLowerCase() 
                        ?
                        <div className="tbp-txn-tabs"
                          style={{
                            flexDirection: 'row',
                            display: 'flex',
                            
                          }}
                        >
                          <Button aria-pressed={String(that.state.moneyTransactionPreset) === "lend"}
                            onClick={() => {
                              that.setState({
                                moneyTransactionPreset: 'lend'
                              })
                            }}
                            style={{
                              backgroundColor: String(that.state.moneyTransactionPreset).toLowerCase() == 'lend' ? 
                              (that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)') 
                              : 
                              (that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)'),
                              width: '8.333333vw',
                              height: '5.3vh',
                              // borderTopLeftRadius: '10px',
                              // borderBottomLeftRadius: '10px',
                              borderColor: 'rgba(177, 177, 177, 0)',
                              color: '177, 177, 177, 1',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginLeft: 0, 
                              marginRight: 0,
                              paddingLeft: 10, 
                              paddingRight: 10,
                              borderRadius: 0,
                            }}
                          >
                            <p
                              style={{
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)', 
                                textAlign: 'center',
                                textAlignVertical: 'center',
                                fontSize: 19,
                                fontWeight: '600',
                              }}
                            >
                              {that.state.selectedLanguage == 'spanish' ? 
                                'Prestar'
                                :
                                'Lend'
                              }
                            </p>
                          </Button>
                          <Button aria-pressed={String(that.state.moneyTransactionPreset) === "reclaim"}
                            onClick={() => {
                              that.setState({
                                moneyTransactionPreset: 'reclaim'
                              })
                            }}
                            style={{
                              backgroundColor: String(that.state.moneyTransactionPreset).toLowerCase() == 'reclaim' ? 
                              (that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)') 
                              : 
                              (that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)'),
                              width: '8.333333vw',
                              height: '5.3vh',
                              borderColor: 'rgba(177, 177, 177, 0)',
                              color: '177, 177, 177, 1',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginLeft: 0, 
                              marginRight: 0,
                              paddingLeft: 10, 
                              paddingRight: 10,
                              borderRadius: 0,
                            }}
                          >
                            <p
                              style={{
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)', 
                                textAlign: 'center',
                                textAlignVertical: 'center',
                                fontSize: 19,
                                fontWeight: '600',
                              }}
                            >
                              {that.state.selectedLanguage == 'spanish' ? 
                                'Reclamar'
                                :
                                'Reclaim'
                              }
                            </p>
                          </Button>
                          <Button aria-pressed={String(that.state.moneyTransactionPreset) === "stake"}
                            onClick={() => {
                              that.setState({
                                moneyTransactionPreset: 'stake',
                                moneyTransactionLiveValue: '',
                                errorTags: null
                              })
                            }}
                            style={{
                              backgroundColor: String(that.state.moneyTransactionPreset).toLowerCase() == 'stake' ? 
                              (that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)') 
                              : 
                              (that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)'),
                              width: '8.333333vw',
                              height: '5.3vh',
                              borderColor: 'rgba(177, 177, 177, 0)',
                              color: '177, 177, 177, 1',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginLeft: 0, 
                              marginRight: 0,
                              paddingLeft: 10, 
                              paddingRight: 10,
                              borderRadius: 0,
                            }}
                          >
                            <p
                              style={{
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)', 
                                textAlign: 'center',
                                textAlignVertical: 'center',
                                fontSize: 19,
                                fontWeight: '600',
                              }}
                            >
                              {that.state.selectedLanguage == 'spanish' ? 
                                'Aportar'
                                :
                                'Stake'
                              }
                            </p>
                          </Button>
                          <Button aria-pressed={String(that.state.moneyTransactionPreset) === "claimRewards"}
                            onClick={() => {
                              const commissionValue = Number(ethers.utils.formatUnits(String(that.state.availableRewards || '0'), 18)).toFixed(2)
                              that.setState({
                                moneyTransactionPreset: 'claimRewards',
                                moneyTransactionLiveValue: commissionValue,
                                errorTags: null
                              })
                            }}
                            style={{
                              backgroundColor: String(that.state.moneyTransactionPreset).toLowerCase() == 'claimrewards' ? 
                              (that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)') 
                              : 
                              (that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)'),
                              width: '8.333333vw',
                              height: '5.3vh',
                              borderColor: 'rgba(177, 177, 177, 0)',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginLeft: 0, 
                              marginRight: 0,
                              paddingLeft: 5, 
                              paddingRight: 5,
                              borderRadius: 0,
                            }}
                          >
                            <p
                              style={{
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)', 
                                textAlign: 'center',
                                textAlignVertical: 'center',
                                fontSize: 14,
                                fontWeight: '600',
                              }}
                            >
                              {that.state.selectedLanguage == 'spanish' ? 'Comisión' : 'Commission'}
                            </p>
                          </Button>
                        </div>
                        :
                        <div className="tbp-txn-tabs"
                          style={{
                            flexDirection: 'row',
                            display: 'flex',
                            
                          }}
                        >
                          <Button aria-pressed={String(that.state.moneyTransactionPreset).toLowerCase() === "repay"}
                            onClick={() => {
                              that.setState({
                                moneyTransactionPreset: 'repay'
                              })
                            }}
                            style={{
                              backgroundColor: String(that.state.moneyTransactionPreset).toLowerCase() == 'repay' ? 
                              (that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)') 
                              : 
                              (that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)'),
                              width: '12.5vw',
                              height: '5.3vh',
                              // borderTopLeftRadius: '10px',
                              // borderBottomLeftRadius: '10px',
                              borderColor: 'rgba(177, 177, 177, 0)',
                              color: '177, 177, 177, 1',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginLeft: 0, 
                              marginRight: 0,
                              paddingLeft: 10, 
                              paddingRight: 10,
                              borderRadius: 0,
                            }}
                          >
                            <p
                              style={{
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)', 
                                textAlign: 'center',
                                textAlignVertical: 'center',
                                fontSize: 16,
                                fontWeight: '600',
                              }}
                            >
                              {that.state.selectedLanguage == 'spanish' ? 
                                'Pagar'
                                :
                                'Repay'
                              }
                            </p>
                          </Button>
                          <Button aria-pressed={String(that.state.moneyTransactionPreset).toLowerCase() === "withdraw"}
                            onClick={() => {
                              that.setState({
                                moneyTransactionPreset: 'withdraw'
                              })
                            }}
                            style={{
                              backgroundColor: String(that.state.moneyTransactionPreset).toLowerCase() == 'withdraw' ? 
                              (that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)') 
                              : 
                              (that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)'),
                              width: '12.5vw',
                              height: '5.3vh',
                              borderColor: 'rgba(177, 177, 177, 0)',
                              color: '177, 177, 177, 1',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginLeft: 0, 
                              marginRight: 0,
                              paddingLeft: 10, 
                              paddingRight: 10,
                              borderRadius: 0,
                            }}
                          >
                            <p
                              style={{
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)', 
                                textAlign: 'center',
                                textAlignVertical: 'center',
                                fontSize: 16,
                                fontWeight: '600',
                              }}
                            >

                              {that.state.selectedLanguage == 'spanish' ? 
                                'Retirar'
                                :
                                'Withdraw'
                              }
                            </p>
                          </Button>
                        </div>
                      }
                      
                    
                      
                      

                      
                      <div className="tbp-txn-amount"><input value={that.state.moneyTransactionLiveValue == null ? '' : that.state.moneyTransactionLiveValue} readOnly={that.state.moneyTransactionPreset == 'claimRewards'} min="0" step="any" aria-label={that.state.selectedLanguage == 'spanish' ? 'Importe en USD' : 'Stake Amount in USD'} 
                        autocomplete="off" 
                        maxlength="5"
                        type="number" 
                        id="text" 
                        outline="none"
                        onChange={(event) => {
                            that.setState({
                              moneyTransactionLiveValue: event.target.value
                            })
                        }} 
                        name="text"
                        placeholder={that.state.moneyTransactionPreset === 'repay'
                          ? Math.min(Number(minimumContribution || 0) / 1e18, Number(_compoundedBalance || 0)).toFixed(2)
                          : that.state.moneyTransactionPreset === 'withdraw' && Number.isFinite(Number(_availableCreditReadyWithdraw))
                            ? Math.max(0, Number(_availableCreditReadyWithdraw)).toFixed(2)
                            : '0'} 
                        style={{
                          fontWeight: '600',
                          fontFamily: 'arial',
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                          paddingRight: '10vw',
                          textAlign: 'center',
                          textAlignVertical: 'center',
                          height: '20vh',
                          width: '25vw',
                          borderRadius: 0,
                          borderWidth: 0,
                          borderStyle: 'none',
                          fontSize: 28,
                          backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)',
                          borderBottomColor: 'rgba(177, 177, 177, 0)',
                        }}
                      /><span className="tbp-txn-currency">USD</span></div>
                      <div className="tbp-txn-limit-hint">
                        {that.state.moneyTransactionPreset === 'claimRewards'
                          ? (that.state.selectedLanguage === 'spanish' ? 'Importe fijo de comisión' : 'Fixed commission amount')
                          : ['lend', 'repay'].includes(that.state.moneyTransactionPreset) && Number(minimumContribution) > 0
                            ? `${that.state.selectedLanguage === 'spanish' ? 'Mínimo' : 'Minimum'}: ${Math.min(Number(minimumContribution) / 1e18, that.state.moneyTransactionPreset === 'repay' ? Number(_compoundedBalance || 0) : Infinity).toFixed(2)} USD`
                            : null}
                      </div>
                      

                      <div className="tbp-txn-cta-stack"
                        style={{
                          marginBottom: 25,
                          height: '9vh',
                          marginTop: 0,
                          width: '25vw',
                          // backgroundColor: that.state.searchedUser_foundUsername ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, 0.1)',
                          borderRadius: 5,
                          justifyContent: 'center',
                          alignItems: 'center',
                          fontSize: 14, 
                          fontWeight: '600',
                        }}
                        // disabled={true}
                      >
                        <Button disabled={that.state.disableWhileTxn || !Number.isFinite(Number(that.state.moneyTransactionLiveValue)) || Number(that.state.moneyTransactionLiveValue) <= 0}
                          onClick={() => {

                           
                            if(Number(that.state.moneyTransactionLiveValue) > 0){
                              {
                                if(that.state.moneyTransactionPreset == 'lend'){
                                  that.setState({
                                    showPasswordOverlay: true,
                                    passwordIsHiddenBool: true,
                                    transactionConfirmationMessage: `Lend ${Number(that.state.moneyTransactionLiveValue).toFixed(2)} USD to ${String(that.state.managerDisplayName).toUpperCase()} 's Credit Line.`
                                  })

                                } else if(that.state.moneyTransactionPreset == 'reclaim'){
                                  that.setState({
                                    showPasswordOverlay: true,
                                    passwordIsHiddenBool: true,
                                    transactionConfirmationMessage: `Reclaim ${Number(that.state.moneyTransactionLiveValue).toFixed(2)} USD from ${String(that.state.managerDisplayName).toUpperCase()} 's Credit Line.`
                                  })
                                } else if(that.state.moneyTransactionPreset == 'stake'){
                                  that.setState({
                                    showPasswordOverlay: true,
                                    passwordIsHiddenBool: true,
                                    transactionConfirmationMessage: `Stake Amount: ${that.state.moneyTransactionLiveValue} USD. Credit Line: ${String(that.state.managerDisplayName).toUpperCase()}. Funds Will Be Added As Collateral.`
                                  })
                                } else if(that.state.moneyTransactionPreset == 'claimRewards'){
                                  that.setState({
                                    showPasswordOverlay: true,
                                    passwordIsHiddenBool: true,
                                    transactionConfirmationMessage: `Withdraw ${Number(that.state.moneyTransactionLiveValue).toFixed(2)} USD in Staking Commissions.`
                                  })
                                } else if(that.state.moneyTransactionPreset == 'repay'){
                                  const minimumRepayValue = Number(minimumContribution || 0) / 1000000000000000000
                                  const remainingDebtValue = Number(_compoundedBalance || 0)
                                  const enteredRepayValueRaw = Number(that.state.moneyTransactionLiveValue || 0)
                                  const enteredRepayValue = Number.isFinite(enteredRepayValueRaw) ? enteredRepayValueRaw : 0
                                  const effectiveMinimumRepay = Math.min(minimumRepayValue, remainingDebtValue)
                                  const normalizedRepayValue = Math.min(
                                    Math.max(enteredRepayValue, effectiveMinimumRepay),
                                    remainingDebtValue
                                  )
                                  that.setState({
                                    moneyTransactionLiveValue: normalizedRepayValue.toFixed(2),
                                    showPasswordOverlay: true,
                                    passwordIsHiddenBool: true,
                                    transactionConfirmationMessage: `Repay ${normalizedRepayValue.toFixed(2)} USD to the Lenders of your Credit Line.`
                                  })
                                } else if(that.state.moneyTransactionPreset == 'withdraw'){
                                  that.setState({
                                    showPasswordOverlay: true,
                                    passwordIsHiddenBool: true,
                                    transactionConfirmationMessage: `Withdraw ${Number(that.state.moneyTransactionLiveValue).toFixed(2)} USD from the Lenders of your Credit Line.`
                                  })
                                }
                              }
                            }
                          }}
                          style={{
                            backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.0)' : 'rgba(255, 255, 255, 0.0)',
                            width: '25vw',
                            height: '6vh',
                            // borderTopLeftRadius: '10px',
                            // borderBottomLeftRadius: '10px',
                            borderColor: 'rgba(177, 177, 177, 0)',
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderBottomStyle: 'solid',
                            borderWidth: 0.1,
                            borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                            borderRadius: 0,
                          }}
                        
                        >
                          <p
                            style={{
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)', 
                              textAlign: 'center',
                              textAlignVertical: 'center',
                              fontSize: 22,
                              fontWeight: '600',
                            }}
                          >

                            {that.state.selectedLanguage == 'spanish' ? 
                              (
                                that.state.moneyTransactionPreset == 'lend' ? 'Prestar' :
                                that.state.moneyTransactionPreset == 'reclaim' ? 'Reclamar' :
                                that.state.moneyTransactionPreset == 'stake' ? 'Aportar' :
                                that.state.moneyTransactionPreset == 'claimRewards' ? 'Retirar Comisión' :
                                that.state.moneyTransactionPreset == 'repay' ? 'Pagar' :
                                that.state.moneyTransactionPreset == 'withdraw' ? 'Retirar' :
                                null
                              )
                              :
                              (
                                that.state.moneyTransactionPreset == 'lend' ? 'Lend' :
                                that.state.moneyTransactionPreset == 'reclaim' ? 'Reclaim' :
                                that.state.moneyTransactionPreset == 'stake' ? 'Stake' :
                                that.state.moneyTransactionPreset == 'claimRewards' ? 'Withdraw Commission' :
                                that.state.moneyTransactionPreset == 'repay' ? 'Repay' :
                                that.state.moneyTransactionPreset == 'withdraw' ? 'Withdraw' :
                                null
                              )
                            }
                          </p>
                        </Button>
                      </div>




                      <div className="tbp-action-panel"
                        style={{
                          marginBottom: 25,
                          height: '50vh',
                          marginTop: '5vh',
                          paddingTop: '5vh',
                          borderTopStyle: 'none',
                          borderWidth: 0.1,
                          borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                          width: '25vw',
                          borderRadius: 5,
                          justifyContent: 'center',
                          alignItems: 'center',
                          fontSize: 14, 
                          fontWeight: '600',
                          // backgroundColor: 'red',
                        }}
                      >
                        














                        {
                          currentUser == managerUsername 
                          // || !that.state.allowsVerifiedRegistryCollateralInsurance 
                            ? 
                            <div className="tbp-action-choices" 
                              style={{
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                // height: 200,
                                // borderWidth: 1,
                                paddingLeft: '2.5vw',
                                width: '25vw',
                                marginLeft: '1vw', 
                                marginRight: 0,
                                marginBottom: 10,
                                // top: 415,
                                zIndex: 1,
                                flexDirection: 'column',
                                display: 'flex',
                                borderRadius: 4,
                                backgroundColor: 'rgba(255, 255, 255, 0)',
                              }}
                            >


                              {
                                [
                                  {
                                    disabled: true,
                                    iconName: 'close icon',
                                    text: that.state.selectedLanguage == 'spanish' ? 'Cerrar esta línea de crédito.' : 'Close this credit line.',
                                    textColor: 'rgba(235, 50, 38, 1)',
                                    onPressFx: () => {
                                      that.setState({
                                        settingsOverlay: false, 
                                      })
                                      if(that.state._canDeleteCreditLineBool){
                                        that.setState({ 
                                          confirmDeleteCreditLineOverlay: true,
                                        })
                                      } else {
                                        that.setState({ 
                                          warningCannotDeleteCreditLineOverlay: true,
                                        })
                                      }
                                    },
                                  },
                                ].map(listItemA => (
                                  <Button className="tbp-action-button" 
                                    disabled={listItemA.disabled}
                                    // disabled={true}
                                    onClick={listItemA.onPressFx}
                                    style={{
                                      marginLeft: 0,
                                      paddingLeft: 0,
                                      paddingRight: 5,
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      height: 40,
                                      left: '0vw',
                                      position: 'relative',
                                      borderRadius: 2,
                                      marginBottom: 25,
                                      // // borderWidth: 2, 
                                      // marginRight: '100vw' - 30 - listItemA.width,
                                      backgroundColor: 'rgba(0, 0, 0, 0)',
                                      width: '17vw',
                                      // backgroundColor:  listItemA.backgroundColor,
                                    }}
                                  > 
                                    <p style={{ 
                                        color: listItemA.textColor,  
                                        fontSize: 17,
                                        textAlign: 'left',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        fontWeight: '600',
                                    }}> 
                                      <i 
                                        className={listItemA.iconName}
                                        size={35} 
                                        style={{ 
                                          position: 'relative', 
                                          color: listItemA.textColor,  
                                          fontSize: 16,
                                        }}
                                      />
                                      &nbsp;
                                      &nbsp;
                                      {listItemA.text}
                                    </p>
                                  </Button>
                                ))
                              }

                            </div> 
                            :
                            <div className="tbp-action-choices" 
                              style={{
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                // height: 200,
                                // borderWidth: 1,
                                paddingLeft: '2.5vw',
                                paddingRight: '7vw',
                                width: '25vw',
                                marginLeft: '1vw', 
                                marginRight: 0,
                                marginBottom: 10,
                                // top: 415,
                                zIndex: 1,
                                flexDirection: 'column',
                                display: 'flex',
                                borderRadius: 4,
                                backgroundColor: 'rgba(255, 255, 255, 0)',
                              }}
                            >


                              {
                                [
                                  {
                                    onPressFx: () => {
                                      that.addWishlist()
                                    },
                                    iconName:  !that.state.inWishlistBool ? 'bookmark outline icon' : 'bookmark icon',
                                    text: 
                                      that.state.selectedLanguage == 'spanish' 
                                      ? 
                                      !that.state.inWishlistBool ? 'Guardar Línea de Crédito' : 'Línea de Crédito se está guardada.'
                                      : 
                                      !that.state.inWishlistBool ? 'Save Credit Line' : 'Credit Line has been saved.',
                                    index: '4',
                                    width: 
                                      that.state.selectedLanguage == 'spanish' 
                                      ? 
                                      !that.state.inWishlistBool ? 75 : 85                          
                                      : 
                                      !that.state.inWishlistBool ? 58 : 65,
                                    textColor: !that.state.inWishlistBool ? (that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)') : 'rgba(0, 158, 129, 1)',
                                    backgroundColor: !that.state.inWishlistBool ? 'rgba(0, 0, 0, 0.05)' : 'rgba(0, 158, 129, 0.07)',
                                    disabled: false,
                                  },
                                ].map(listItemA => (
                                  <Button className="tbp-action-button" 
                                    disabled={listItemA.disabled}
                                    onClick={listItemA.onPressFx}
                                    style={{
                                      marginLeft: 0,
                                      paddingLeft: 0,
                                      paddingRight: 5,
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      height: 40,
                                      left: '0vw',
                                      position: 'relative',
                                      borderRadius: 2,
                                      marginBottom: 25,
                                      // // borderWidth: 2, 
                                      // marginRight: '100vw' - 30 - listItemA.width,
                                      backgroundColor: 'rgba(0, 0, 0, 0)',
                                      width: '17vw',
                                      // backgroundColor:  listItemA.backgroundColor,
                                    }}
                                  > 
                                    <p style={{ 
                                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)', // listItemA.textColor,  
                                        fontSize: 17,
                                        textAlign: 'left',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        fontWeight: '600',
                                    }}> 
                                      <i 
                                        className={listItemA.iconName}
                                        size={35} 
                                        style={{ 
                                          position: 'relative', 
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)', // listItemA.textColor,  
                                          fontSize: 16,
                                        }}
                                      />
                                      &nbsp;
                                      &nbsp;
                                      {listItemA.text}
                                    </p>
                                  </Button>
                                ))
                              }

                            </div> 
                        }





                        
                      </div>

                    </div>







                  </div>
                  
                </div>

              </div>

          </div>
        )
    );
  }
}

export default BorrowingAccountDesktopRender;
